/**
 * IDF Field Mappings for HVAC/Plant Components
 *
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated from EnergyPlus IDD schema by scanning for node fields
 * Run: npm run generate:mappings
 */

import type { ComponentIDFMapping } from './types';

/**
 * Field mappings for all HVAC/Plant components with node connections
 * Auto-detected from IDD - any object with node-type fields is included
 */
export const COMPONENT_IDF_MAPPINGS: ComponentIDFMapping[] = [
  {
    componentType: 'window-property-airflow-control',
    idfClass: 'WindowProperty:AirflowControl',
    nameFieldIndex: 0,
    totalFields: 8,
    fieldMappings: {},
    portMappings: [
      { portId: 'airflow-return-air', fieldIndex: 7, fieldName: 'Airflow Return Air Node Name' },
    ],
  },
  {
    componentType: 'lights',
    idfClass: 'Lights',
    nameFieldIndex: 0,
    totalFields: 17,
    fieldMappings: {},
    portMappings: [
      { portId: 'return-air-heat-gain', fieldIndex: 15, fieldName: 'Return Air Heat Gain Node Name' },
    ],
  },
  {
    componentType: 'swimming-pool-indoor',
    idfClass: 'SwimmingPool:Indoor',
    nameFieldIndex: 0,
    totalFields: 18,
    fieldMappings: {},
    portMappings: [
      { portId: 'pool-water-inlet-node', fieldIndex: 10, fieldName: 'Pool Water Inlet Node' },
      { portId: 'pool-water-outlet-node', fieldIndex: 11, fieldName: 'Pool Water Outlet Node' },
    ],
  },
  {
    componentType: 'zone-hvac-ideal-loads-air-system',
    idfClass: 'ZoneHVAC:IdealLoadsAirSystem',
    nameFieldIndex: 0,
    totalFields: 32,
    fieldMappings: {},
    portMappings: [
      { portId: 'system-inlet-air', fieldIndex: 4, fieldName: 'System Inlet Air Node Name' },
      { portId: 'outdoor-air-inlet', fieldIndex: 21, fieldName: 'Outdoor Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-four-pipe-fan-coil',
    idfClass: 'ZoneHVAC:FourPipeFanCoil',
    nameFieldIndex: 0,
    totalFields: 29,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 8, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 9, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-window-air-conditioner',
    idfClass: 'ZoneHVAC:WindowAirConditioner',
    nameFieldIndex: 0,
    totalFields: 17,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 4, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 5, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-packaged-terminal-air-conditioner',
    idfClass: 'ZoneHVAC:PackagedTerminalAirConditioner',
    nameFieldIndex: 0,
    totalFields: 26,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 2, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 3, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-packaged-terminal-heat-pump',
    idfClass: 'ZoneHVAC:PackagedTerminalHeatPump',
    nameFieldIndex: 0,
    totalFields: 33,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 2, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 3, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-water-to-air-heat-pump',
    idfClass: 'ZoneHVAC:WaterToAirHeatPump',
    nameFieldIndex: 0,
    totalFields: 32,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 2, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 3, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-dehumidifier-dx',
    idfClass: 'ZoneHVAC:Dehumidifier:DX',
    nameFieldIndex: 0,
    totalFields: 14,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 2, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 3, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-unit-ventilator',
    idfClass: 'ZoneHVAC:UnitVentilator',
    nameFieldIndex: 0,
    totalFields: 25,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 8, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 9, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-unit-heater',
    idfClass: 'ZoneHVAC:UnitHeater',
    nameFieldIndex: 0,
    totalFields: 16,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 2, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 3, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-evaporative-cooler-unit',
    idfClass: 'ZoneHVAC:EvaporativeCoolerUnit',
    nameFieldIndex: 0,
    totalFields: 19,
    fieldMappings: {},
    portMappings: [
      { portId: 'outdoor-air-inlet', fieldIndex: 3, fieldName: 'Outdoor Air Inlet Node Name' },
      { portId: 'cooler-outlet', fieldIndex: 4, fieldName: 'Cooler Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-hybrid-unitary-hvac',
    idfClass: 'ZoneHVAC:HybridUnitaryHVAC',
    nameFieldIndex: 0,
    totalFields: 660,
    fieldMappings: {},
    portMappings: [
      { portId: 'return-air', fieldIndex: 8, fieldName: 'Return Air Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-outdoor-air-unit',
    idfClass: 'ZoneHVAC:OutdoorAirUnit',
    nameFieldIndex: 0,
    totalFields: 19,
    fieldMappings: {},
    portMappings: [
      { portId: 'airoutlet', fieldIndex: 14, fieldName: 'AirOutlet Node Name' },
      { portId: 'airinlet', fieldIndex: 15, fieldName: 'AirInlet Node Name' },
      { portId: 'supply-fanoutlet', fieldIndex: 16, fieldName: 'Supply FanOutlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-terminal-unit-variable-refrigerant-flow',
    idfClass: 'ZoneHVAC:TerminalUnit:VariableRefrigerantFlow',
    nameFieldIndex: 0,
    totalFields: 33,
    fieldMappings: {},
    portMappings: [
      { portId: 'terminal-unit-air-inlet', fieldIndex: 2, fieldName: 'Terminal Unit Air Inlet Node Name' },
      { portId: 'terminal-unit-air-outlet', fieldIndex: 3, fieldName: 'Terminal Unit Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-baseboard-radiant-convective-water',
    idfClass: 'ZoneHVAC:Baseboard:RadiantConvective:Water',
    nameFieldIndex: 0,
    totalFields: 209,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 3, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 4, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-baseboard-radiant-convective-steam',
    idfClass: 'ZoneHVAC:Baseboard:RadiantConvective:Steam',
    nameFieldIndex: 0,
    totalFields: 208,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 3, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 4, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-cooling-panel-radiant-convective-water',
    idfClass: 'ZoneHVAC:CoolingPanel:RadiantConvective:Water',
    nameFieldIndex: 0,
    totalFields: 219,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 2, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 3, fieldName: 'Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-baseboard-convective-water',
    idfClass: 'ZoneHVAC:Baseboard:Convective:Water',
    nameFieldIndex: 0,
    totalFields: 11,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 2, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 3, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-low-temperature-radiant-variable-flow',
    idfClass: 'ZoneHVAC:LowTemperatureRadiant:VariableFlow',
    nameFieldIndex: 0,
    totalFields: 16,
    fieldMappings: {},
    portMappings: [
      { portId: 'heating-water-inlet', fieldIndex: 8, fieldName: 'Heating Water Inlet Node Name' },
      { portId: 'heating-water-outlet', fieldIndex: 9, fieldName: 'Heating Water Outlet Node Name' },
      { portId: 'cooling-water-inlet', fieldIndex: 12, fieldName: 'Cooling Water Inlet Node Name' },
      { portId: 'cooling-water-outlet', fieldIndex: 13, fieldName: 'Cooling Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-low-temperature-radiant-constant-flow',
    idfClass: 'ZoneHVAC:LowTemperatureRadiant:ConstantFlow',
    nameFieldIndex: 0,
    totalFields: 24,
    fieldMappings: {},
    portMappings: [
      { portId: 'heating-water-inlet', fieldIndex: 10, fieldName: 'Heating Water Inlet Node Name' },
      { portId: 'heating-water-outlet', fieldIndex: 11, fieldName: 'Heating Water Outlet Node Name' },
      { portId: 'cooling-water-inlet', fieldIndex: 16, fieldName: 'Cooling Water Inlet Node Name' },
      { portId: 'cooling-water-outlet', fieldIndex: 17, fieldName: 'Cooling Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-ventilated-slab',
    idfClass: 'ZoneHVAC:VentilatedSlab',
    nameFieldIndex: 0,
    totalFields: 40,
    fieldMappings: {},
    portMappings: [
      { portId: 'return-air', fieldIndex: 23, fieldName: 'Return Air Node Name' },
      { portId: 'outdoor-air-mixer-outlet', fieldIndex: 28, fieldName: 'Outdoor Air Mixer Outlet Node Name' },
      { portId: 'fan-outlet', fieldIndex: 29, fieldName: 'Fan Outlet Node Name' },
      { portId: 'hot-water-or-steam-inlet', fieldIndex: 34, fieldName: 'Hot Water or Steam Inlet Node Name' },
      { portId: 'cold-water-inlet', fieldIndex: 37, fieldName: 'Cold Water Inlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-ventilated-slab-slab-group',
    idfClass: 'ZoneHVAC:VentilatedSlab:SlabGroup',
    nameFieldIndex: 0,
    totalFields: 71,
    fieldMappings: {},
    portMappings: [
      { portId: 'slab-inlet-node-name-for-surface-1', fieldIndex: 6, fieldName: 'Slab Inlet Node Name for Surface 1' },
      { portId: 'slab-outlet-node-name-for-surface-1', fieldIndex: 7, fieldName: 'Slab Outlet Node Name for Surface 1' },
      { portId: 'slab-inlet-node-name-for-surface-2', fieldIndex: 13, fieldName: 'Slab Inlet Node Name for Surface 2' },
      { portId: 'slab-outlet-node-name-for-surface-2', fieldIndex: 14, fieldName: 'Slab Outlet Node Name for Surface 2' },
      { portId: 'slab-inlet-node-name-for-surface-3', fieldIndex: 20, fieldName: 'Slab Inlet Node Name for Surface 3' },
      { portId: 'slab-outlet-node-name-for-surface-3', fieldIndex: 21, fieldName: 'Slab Outlet Node Name for Surface 3' },
      { portId: 'slab-inlet-node-name-for-surface-4', fieldIndex: 27, fieldName: 'Slab Inlet Node Name for Surface 4' },
      { portId: 'slab-outlet-node-name-for-surface-4', fieldIndex: 28, fieldName: 'Slab Outlet Node Name for Surface 4' },
      { portId: 'slab-inlet-node-name-for-surface-5', fieldIndex: 34, fieldName: 'Slab Inlet Node Name for Surface 5' },
      { portId: 'slab-outlet-node-name-for-surface-5', fieldIndex: 35, fieldName: 'Slab Outlet Node Name for Surface 5' },
      { portId: 'slab-inlet-node-name-for-surface-6', fieldIndex: 41, fieldName: 'Slab Inlet Node Name for Surface 6' },
      { portId: 'slab-outlet-node-name-for-surface-6', fieldIndex: 42, fieldName: 'Slab Outlet Node Name for Surface 6' },
      { portId: 'slab-inlet-node-name-for-surface-7', fieldIndex: 48, fieldName: 'Slab Inlet Node Name for Surface 7' },
      { portId: 'slab-outlet-node-name-for-surface-7', fieldIndex: 49, fieldName: 'Slab Outlet Node Name for Surface 7' },
      { portId: 'slab-inlet-node-name-for-surface-8', fieldIndex: 55, fieldName: 'Slab Inlet Node Name for Surface 8' },
      { portId: 'slab-outlet-node-name-for-surface-8', fieldIndex: 56, fieldName: 'Slab Outlet Node Name for Surface 8' },
      { portId: 'slab-inlet-node-name-for-surface-9', fieldIndex: 62, fieldName: 'Slab Inlet Node Name for Surface 9' },
      { portId: 'slab-outlet-node-name-for-surface-9', fieldIndex: 63, fieldName: 'Slab Outlet Node Name for Surface 9' },
      { portId: 'slab-inlet-node-name-for-surface-10', fieldIndex: 69, fieldName: 'Slab Inlet Node Name for Surface 10' },
      { portId: 'slab-outlet-node-name-for-surface-10', fieldIndex: 70, fieldName: 'Slab Outlet Node Name for Surface 10' },
    ],
  },
  {
    componentType: 'air-terminal-single-duct-constant-volume-reheat',
    idfClass: 'AirTerminal:SingleDuct:ConstantVolume:Reheat',
    nameFieldIndex: 0,
    totalFields: 11,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-outlet', fieldIndex: 2, fieldName: 'Air Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 3, fieldName: 'Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-single-duct-constant-volume-no-reheat',
    idfClass: 'AirTerminal:SingleDuct:ConstantVolume:NoReheat',
    nameFieldIndex: 0,
    totalFields: 7,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 2, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 3, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-single-duct-vav-no-reheat',
    idfClass: 'AirTerminal:SingleDuct:VAV:NoReheat',
    nameFieldIndex: 0,
    totalFields: 11,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-outlet', fieldIndex: 2, fieldName: 'Air Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 3, fieldName: 'Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-single-duct-vav-reheat',
    idfClass: 'AirTerminal:SingleDuct:VAV:Reheat',
    nameFieldIndex: 0,
    totalFields: 21,
    fieldMappings: {},
    portMappings: [
      { portId: 'damper-air-outlet', fieldIndex: 2, fieldName: 'Damper Air Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 3, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 13, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-single-duct-vav-reheat-variable-speed-fan',
    idfClass: 'AirTerminal:SingleDuct:VAV:Reheat:VariableSpeedFan',
    nameFieldIndex: 0,
    totalFields: 15,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 5, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 6, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-single-duct-vav-heat-and-cool-no-reheat',
    idfClass: 'AirTerminal:SingleDuct:VAV:HeatAndCool:NoReheat',
    nameFieldIndex: 0,
    totalFields: 7,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-outlet', fieldIndex: 2, fieldName: 'Air Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 3, fieldName: 'Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-single-duct-vav-heat-and-cool-reheat',
    idfClass: 'AirTerminal:SingleDuct:VAV:HeatAndCool:Reheat',
    nameFieldIndex: 0,
    totalFields: 14,
    fieldMappings: {},
    portMappings: [
      { portId: 'damper-air-outlet', fieldIndex: 2, fieldName: 'Damper Air Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 3, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 10, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-single-duct-series-piu-reheat',
    idfClass: 'AirTerminal:SingleDuct:SeriesPIU:Reheat',
    nameFieldIndex: 0,
    totalFields: 20,
    fieldMappings: {},
    portMappings: [
      { portId: 'supply-air-inlet', fieldIndex: 5, fieldName: 'Supply Air Inlet Node Name' },
      { portId: 'secondary-air-inlet', fieldIndex: 6, fieldName: 'Secondary Air Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 7, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-single-duct-parallel-piu-reheat',
    idfClass: 'AirTerminal:SingleDuct:ParallelPIU:Reheat',
    nameFieldIndex: 0,
    totalFields: 21,
    fieldMappings: {},
    portMappings: [
      { portId: 'supply-air-inlet', fieldIndex: 6, fieldName: 'Supply Air Inlet Node Name' },
      { portId: 'secondary-air-inlet', fieldIndex: 7, fieldName: 'Secondary Air Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 8, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-single-duct-constant-volume-four-pipe-induction',
    idfClass: 'AirTerminal:SingleDuct:ConstantVolume:FourPipeInduction',
    nameFieldIndex: 0,
    totalFields: 18,
    fieldMappings: {},
    portMappings: [
      { portId: 'supply-air-inlet', fieldIndex: 4, fieldName: 'Supply Air Inlet Node Name' },
      { portId: 'induced-air-inlet', fieldIndex: 5, fieldName: 'Induced Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 6, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-single-duct-constant-volume-four-pipe-beam',
    idfClass: 'AirTerminal:SingleDuct:ConstantVolume:FourPipeBeam',
    nameFieldIndex: 0,
    totalFields: 27,
    fieldMappings: {},
    portMappings: [
      { portId: 'primary-air-inlet', fieldIndex: 4, fieldName: 'Primary Air Inlet Node Name' },
      { portId: 'primary-air-outlet', fieldIndex: 5, fieldName: 'Primary Air Outlet Node Name' },
      { portId: 'chilled-water-inlet', fieldIndex: 6, fieldName: 'Chilled Water Inlet Node Name' },
      { portId: 'chilled-water-outlet', fieldIndex: 7, fieldName: 'Chilled Water Outlet Node Name' },
      { portId: 'hot-water-inlet', fieldIndex: 8, fieldName: 'Hot Water Inlet Node Name' },
      { portId: 'hot-water-outlet', fieldIndex: 9, fieldName: 'Hot Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-single-duct-constant-volume-cooled-beam',
    idfClass: 'AirTerminal:SingleDuct:ConstantVolume:CooledBeam',
    nameFieldIndex: 0,
    totalFields: 23,
    fieldMappings: {},
    portMappings: [
      { portId: 'supply-air-inlet', fieldIndex: 3, fieldName: 'Supply Air Inlet Node Name' },
      { portId: 'supply-air-outlet', fieldIndex: 4, fieldName: 'Supply Air Outlet Node Name' },
      { portId: 'chilled-water-inlet', fieldIndex: 5, fieldName: 'Chilled Water Inlet Node Name' },
      { portId: 'chilled-water-outlet', fieldIndex: 6, fieldName: 'Chilled Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-single-duct-mixer',
    idfClass: 'AirTerminal:SingleDuct:Mixer',
    nameFieldIndex: 0,
    totalFields: 9,
    fieldMappings: {},
    portMappings: [
      { portId: 'mixer-outlet', fieldIndex: 3, fieldName: 'Mixer Outlet Node Name' },
      { portId: 'mixer-primary-air-inlet', fieldIndex: 4, fieldName: 'Mixer Primary Air Inlet Node Name' },
      { portId: 'mixer-secondary-air-inlet', fieldIndex: 5, fieldName: 'Mixer Secondary Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-dual-duct-constant-volume',
    idfClass: 'AirTerminal:DualDuct:ConstantVolume',
    nameFieldIndex: 0,
    totalFields: 6,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-outlet', fieldIndex: 2, fieldName: 'Air Outlet Node Name' },
      { portId: 'hot-air-inlet', fieldIndex: 3, fieldName: 'Hot Air Inlet Node Name' },
      { portId: 'cold-air-inlet', fieldIndex: 4, fieldName: 'Cold Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-dual-duct-vav',
    idfClass: 'AirTerminal:DualDuct:VAV',
    nameFieldIndex: 0,
    totalFields: 9,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-outlet', fieldIndex: 2, fieldName: 'Air Outlet Node Name' },
      { portId: 'hot-air-inlet', fieldIndex: 3, fieldName: 'Hot Air Inlet Node Name' },
      { portId: 'cold-air-inlet', fieldIndex: 4, fieldName: 'Cold Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-dual-duct-vav-outdoor-air',
    idfClass: 'AirTerminal:DualDuct:VAV:OutdoorAir',
    nameFieldIndex: 0,
    totalFields: 8,
    fieldMappings: {},
    portMappings: [
      { portId: 'outdoor-air-inlet', fieldIndex: 3, fieldName: 'Outdoor Air Inlet Node Name' },
      { portId: 'recirculated-air-inlet', fieldIndex: 4, fieldName: 'Recirculated Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-air-distribution-unit',
    idfClass: 'ZoneHVAC:AirDistributionUnit',
    nameFieldIndex: 0,
    totalFields: 7,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-distribution-unit-outlet', fieldIndex: 1, fieldName: 'Air Distribution Unit Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-exhaust-control',
    idfClass: 'ZoneHVAC:ExhaustControl',
    nameFieldIndex: 0,
    totalFields: 12,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 3, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 4, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-equipment-connections',
    idfClass: 'ZoneHVAC:EquipmentConnections',
    nameFieldIndex: 0,
    totalFields: 8,
    fieldMappings: {},
    portMappings: [
      { portId: 'zone-air-inlet-node-or-nodelist-name', fieldIndex: 2, fieldName: 'Zone Air Inlet Node or NodeList Name' },
      { portId: 'zone-return-air-node-or-nodelist-name', fieldIndex: 5, fieldName: 'Zone Return Air Node or NodeList Name' },
      { portId: 'zone-return-air-node-1-flow-rate-basis-node-or-nodelist-name', fieldIndex: 7, fieldName: 'Zone Return Air Node 1 Flow Rate Basis Node or NodeList Name' },
    ],
  },
  {
    componentType: 'space-hvac-equipment-connections',
    idfClass: 'SpaceHVAC:EquipmentConnections',
    nameFieldIndex: 0,
    totalFields: 7,
    fieldMappings: {},
    portMappings: [
      { portId: 'space-air-inlet-node-or-nodelist-name', fieldIndex: 1, fieldName: 'Space Air Inlet Node or NodeList Name' },
      { portId: 'space-return-air-node-or-nodelist-name', fieldIndex: 4, fieldName: 'Space Return Air Node or NodeList Name' },
      { portId: 'space-return-air-node-1-flow-rate-basis-node-or-nodelist-name', fieldIndex: 6, fieldName: 'Space Return Air Node 1 Flow Rate Basis Node or NodeList Name' },
    ],
  },
  {
    componentType: 'space-hvac-zone-equipment-splitter',
    idfClass: 'SpaceHVAC:ZoneEquipmentSplitter',
    nameFieldIndex: 0,
    totalFields: 17,
    fieldMappings: {},
    portMappings: [
      { portId: 'zone-equipment-outlet', fieldIndex: 4, fieldName: 'Zone Equipment Outlet Node Name' },
    ],
  },
  {
    componentType: 'space-hvac-zone-equipment-mixer',
    idfClass: 'SpaceHVAC:ZoneEquipmentMixer',
    nameFieldIndex: 0,
    totalFields: 13,
    fieldMappings: {},
    portMappings: [
      { portId: 'zone-equipment-inlet', fieldIndex: 2, fieldName: 'Zone Equipment Inlet Node Name' },
    ],
  },
  {
    componentType: 'space-hvac-zone-return-mixer',
    idfClass: 'SpaceHVAC:ZoneReturnMixer',
    nameFieldIndex: 0,
    totalFields: 13,
    fieldMappings: {},
    portMappings: [
      { portId: 'zone-return-air', fieldIndex: 2, fieldName: 'Zone Return Air Node Name' },
      { portId: 'space-1-return-air', fieldIndex: 4, fieldName: 'Space 1 Return Air Node Name' },
      { portId: 'space-2-return-air', fieldIndex: 6, fieldName: 'Space 2 Return Air Node Name' },
      { portId: 'space-3-return-air', fieldIndex: 8, fieldName: 'Space 3 Return Air Node Name' },
      { portId: 'space-4-return-air', fieldIndex: 10, fieldName: 'Space 4 Return Air Node Name' },
      { portId: 'space-5-return-air', fieldIndex: 12, fieldName: 'Space 5 Return Air Node Name' },
    ],
  },
  {
    componentType: 'fan-system-model',
    idfClass: 'Fan:SystemModel',
    nameFieldIndex: 0,
    totalFields: 30,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 2, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 3, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'fan-constant-volume',
    idfClass: 'Fan:ConstantVolume',
    nameFieldIndex: 0,
    totalFields: 10,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 7, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 8, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'fan-variable-volume',
    idfClass: 'Fan:VariableVolume',
    nameFieldIndex: 0,
    totalFields: 18,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 15, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 16, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'fan-on-off',
    idfClass: 'Fan:OnOff',
    nameFieldIndex: 0,
    totalFields: 12,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 7, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 8, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'fan-zone-exhaust',
    idfClass: 'Fan:ZoneExhaust',
    nameFieldIndex: 0,
    totalFields: 12,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 5, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 6, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'fan-component-model',
    idfClass: 'Fan:ComponentModel',
    nameFieldIndex: 0,
    totalFields: 37,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 1, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 2, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-cooling-water',
    idfClass: 'Coil:Cooling:Water',
    nameFieldIndex: 0,
    totalFields: 17,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 9, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 10, fieldName: 'Water Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 11, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 12, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-cooling-water-detailed-geometry',
    idfClass: 'Coil:Cooling:Water:DetailedGeometry',
    nameFieldIndex: 0,
    totalFields: 25,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 18, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 19, fieldName: 'Water Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 20, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 21, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-system-cooling-water',
    idfClass: 'CoilSystem:Cooling:Water',
    nameFieldIndex: 0,
    totalFields: 13,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 1, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 2, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-cooling-dx',
    idfClass: 'Coil:Cooling:DX',
    nameFieldIndex: 0,
    totalFields: 10,
    fieldMappings: {},
    portMappings: [
      { portId: 'evaporator-inlet', fieldIndex: 1, fieldName: 'Evaporator Inlet Node Name' },
      { portId: 'evaporator-outlet', fieldIndex: 2, fieldName: 'Evaporator Outlet Node Name' },
      { portId: 'condenser-inlet', fieldIndex: 5, fieldName: 'Condenser Inlet Node Name' },
      { portId: 'condenser-outlet', fieldIndex: 6, fieldName: 'Condenser Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-cooling-dx-single-speed',
    idfClass: 'Coil:Cooling:DX:SingleSpeed',
    nameFieldIndex: 0,
    totalFields: 37,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 8, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 9, fieldName: 'Air Outlet Node Name' },
      { portId: 'condenser-air-inlet', fieldIndex: 20, fieldName: 'Condenser Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'coil-cooling-dx-two-speed',
    idfClass: 'Coil:Cooling:DX:TwoSpeed',
    nameFieldIndex: 0,
    totalFields: 43,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 9, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 10, fieldName: 'Air Outlet Node Name' },
      { portId: 'condenser-air-inlet', fieldIndex: 24, fieldName: 'Condenser Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'coil-cooling-dx-multi-speed',
    idfClass: 'Coil:Cooling:DX:MultiSpeed',
    nameFieldIndex: 0,
    totalFields: 100,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 2, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 3, fieldName: 'Air Outlet Node Name' },
      { portId: 'condenser-air-inlet', fieldIndex: 4, fieldName: 'Condenser Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'coil-cooling-dx-variable-speed',
    idfClass: 'Coil:Cooling:DX:VariableSpeed',
    nameFieldIndex: 0,
    totalFields: 146,
    fieldMappings: {},
    portMappings: [
      { portId: 'indoor-air-inlet', fieldIndex: 2, fieldName: 'Indoor Air Inlet Node Name' },
      { portId: 'indoor-air-outlet', fieldIndex: 3, fieldName: 'Indoor Air Outlet Node Name' },
      { portId: 'condenser-air-inlet', fieldIndex: 14, fieldName: 'Condenser Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'coil-cooling-dx-two-stage-with-humidity-control-mode',
    idfClass: 'Coil:Cooling:DX:TwoStageWithHumidityControlMode',
    nameFieldIndex: 0,
    totalFields: 23,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 2, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 3, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-performance-dx-cooling',
    idfClass: 'CoilPerformance:DX:Cooling',
    nameFieldIndex: 0,
    totalFields: 22,
    fieldMappings: {},
    portMappings: [
      { portId: 'condenser-air-inlet', fieldIndex: 15, fieldName: 'Condenser Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'coil-cooling-dx-variable-refrigerant-flow',
    idfClass: 'Coil:Cooling:DX:VariableRefrigerantFlow',
    nameFieldIndex: 0,
    totalFields: 10,
    fieldMappings: {},
    portMappings: [
      { portId: 'coil-air-inlet-node', fieldIndex: 7, fieldName: 'Coil Air Inlet Node' },
      { portId: 'coil-air-outlet-node', fieldIndex: 8, fieldName: 'Coil Air Outlet Node' },
    ],
  },
  {
    componentType: 'coil-heating-dx-variable-refrigerant-flow',
    idfClass: 'Coil:Heating:DX:VariableRefrigerantFlow',
    nameFieldIndex: 0,
    totalFields: 8,
    fieldMappings: {},
    portMappings: [
      { portId: 'coil-air-inlet-node', fieldIndex: 4, fieldName: 'Coil Air Inlet Node' },
      { portId: 'coil-air-outlet-node', fieldIndex: 5, fieldName: 'Coil Air Outlet Node' },
    ],
  },
  {
    componentType: 'coil-cooling-dx-variable-refrigerant-flow-fluid-temperature-control',
    idfClass: 'Coil:Cooling:DX:VariableRefrigerantFlow:FluidTemperatureControl',
    nameFieldIndex: 0,
    totalFields: 9,
    fieldMappings: {},
    portMappings: [
      { portId: 'coil-air-inlet-node', fieldIndex: 2, fieldName: 'Coil Air Inlet Node' },
      { portId: 'coil-air-outlet-node', fieldIndex: 3, fieldName: 'Coil Air Outlet Node' },
    ],
  },
  {
    componentType: 'coil-heating-dx-variable-refrigerant-flow-fluid-temperature-control',
    idfClass: 'Coil:Heating:DX:VariableRefrigerantFlow:FluidTemperatureControl',
    nameFieldIndex: 0,
    totalFields: 7,
    fieldMappings: {},
    portMappings: [
      { portId: 'coil-air-inlet-node', fieldIndex: 2, fieldName: 'Coil Air Inlet Node' },
      { portId: 'coil-air-outlet-node', fieldIndex: 3, fieldName: 'Coil Air Outlet Node' },
    ],
  },
  {
    componentType: 'coil-heating-water',
    idfClass: 'Coil:Heating:Water',
    nameFieldIndex: 0,
    totalFields: 16,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 4, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 5, fieldName: 'Water Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 6, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 7, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-heating-steam',
    idfClass: 'Coil:Heating:Steam',
    nameFieldIndex: 0,
    totalFields: 11,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 5, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 6, fieldName: 'Water Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 7, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 8, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-heating-electric',
    idfClass: 'Coil:Heating:Electric',
    nameFieldIndex: 0,
    totalFields: 7,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 4, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 5, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-heating-electric-multi-stage',
    idfClass: 'Coil:Heating:Electric:MultiStage',
    nameFieldIndex: 0,
    totalFields: 14,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 2, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 3, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-heating-fuel',
    idfClass: 'Coil:Heating:Fuel',
    nameFieldIndex: 0,
    totalFields: 11,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 5, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 6, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-heating-gas-multi-stage',
    idfClass: 'Coil:Heating:Gas:MultiStage',
    nameFieldIndex: 0,
    totalFields: 20,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 2, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 3, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-heating-desuperheater',
    idfClass: 'Coil:Heating:Desuperheater',
    nameFieldIndex: 0,
    totalFields: 9,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 3, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 4, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-heating-dx-single-speed',
    idfClass: 'Coil:Heating:DX:SingleSpeed',
    nameFieldIndex: 0,
    totalFields: 33,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 7, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 8, fieldName: 'Air Outlet Node Name' },
      { portId: 'evaporator-air-inlet', fieldIndex: 26, fieldName: 'Evaporator Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'coil-heating-dx-multi-speed',
    idfClass: 'Coil:Heating:DX:MultiSpeed',
    nameFieldIndex: 0,
    totalFields: 88,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 2, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 3, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-heating-dx-variable-speed',
    idfClass: 'Coil:Heating:DX:VariableSpeed',
    nameFieldIndex: 0,
    totalFields: 110,
    fieldMappings: {},
    portMappings: [
      { portId: 'indoor-air-inlet', fieldIndex: 2, fieldName: 'Indoor Air Inlet Node Name' },
      { portId: 'indoor-air-outlet', fieldIndex: 3, fieldName: 'Indoor Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-cooling-water-to-air-heat-pump-parameter-estimation',
    idfClass: 'Coil:Cooling:WaterToAirHeatPump:ParameterEstimation',
    nameFieldIndex: 0,
    totalFields: 32,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 10, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 11, fieldName: 'Water Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 12, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 13, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-heating-water-to-air-heat-pump-parameter-estimation',
    idfClass: 'Coil:Heating:WaterToAirHeatPump:ParameterEstimation',
    nameFieldIndex: 0,
    totalFields: 26,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 8, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 9, fieldName: 'Water Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 10, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 11, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-cooling-water-to-air-heat-pump-equation-fit',
    idfClass: 'Coil:Cooling:WaterToAirHeatPump:EquationFit',
    nameFieldIndex: 0,
    totalFields: 23,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 2, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 3, fieldName: 'Water Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 4, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 5, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-cooling-water-to-air-heat-pump-variable-speed-equation-fit',
    idfClass: 'Coil:Cooling:WaterToAirHeatPump:VariableSpeedEquationFit',
    nameFieldIndex: 0,
    totalFields: 148,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-to-refrigerant-hx-water-inlet', fieldIndex: 2, fieldName: 'Water-to-Refrigerant HX Water Inlet Node Name' },
      { portId: 'water-to-refrigerant-hx-water-outlet', fieldIndex: 3, fieldName: 'Water-to-Refrigerant HX Water Outlet Node Name' },
      { portId: 'indoor-air-inlet', fieldIndex: 4, fieldName: 'Indoor Air Inlet Node Name' },
      { portId: 'indoor-air-outlet', fieldIndex: 5, fieldName: 'Indoor Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-heating-water-to-air-heat-pump-equation-fit',
    idfClass: 'Coil:Heating:WaterToAirHeatPump:EquationFit',
    nameFieldIndex: 0,
    totalFields: 16,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 2, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 3, fieldName: 'Water Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 4, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 5, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-heating-water-to-air-heat-pump-variable-speed-equation-fit',
    idfClass: 'Coil:Heating:WaterToAirHeatPump:VariableSpeedEquationFit',
    nameFieldIndex: 0,
    totalFields: 132,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-to-refrigerant-hx-water-inlet', fieldIndex: 2, fieldName: 'Water-to-Refrigerant HX Water Inlet Node Name' },
      { portId: 'water-to-refrigerant-hx-water-outlet', fieldIndex: 3, fieldName: 'Water-to-Refrigerant HX Water Outlet Node Name' },
      { portId: 'indoor-air-inlet', fieldIndex: 4, fieldName: 'Indoor Air Inlet Node Name' },
      { portId: 'indoor-air-outlet', fieldIndex: 5, fieldName: 'Indoor Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-water-heating-air-to-water-heat-pump-pumped',
    idfClass: 'Coil:WaterHeating:AirToWaterHeatPump:Pumped',
    nameFieldIndex: 0,
    totalFields: 30,
    fieldMappings: {},
    portMappings: [
      { portId: 'evaporator-air-inlet', fieldIndex: 15, fieldName: 'Evaporator Air Inlet Node Name' },
      { portId: 'evaporator-air-outlet', fieldIndex: 16, fieldName: 'Evaporator Air Outlet Node Name' },
      { portId: 'condenser-water-inlet', fieldIndex: 17, fieldName: 'Condenser Water Inlet Node Name' },
      { portId: 'condenser-water-outlet', fieldIndex: 18, fieldName: 'Condenser Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-water-heating-air-to-water-heat-pump-wrapped',
    idfClass: 'Coil:WaterHeating:AirToWaterHeatPump:Wrapped',
    nameFieldIndex: 0,
    totalFields: 21,
    fieldMappings: {},
    portMappings: [
      { portId: 'evaporator-air-inlet', fieldIndex: 10, fieldName: 'Evaporator Air Inlet Node Name' },
      { portId: 'evaporator-air-outlet', fieldIndex: 11, fieldName: 'Evaporator Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-water-heating-air-to-water-heat-pump-variable-speed',
    idfClass: 'Coil:WaterHeating:AirToWaterHeatPump:VariableSpeed',
    nameFieldIndex: 0,
    totalFields: 143,
    fieldMappings: {},
    portMappings: [
      { portId: 'evaporator-air-inlet', fieldIndex: 14, fieldName: 'Evaporator Air Inlet Node Name' },
      { portId: 'evaporator-air-outlet', fieldIndex: 15, fieldName: 'Evaporator Air Outlet Node Name' },
      { portId: 'condenser-water-inlet', fieldIndex: 16, fieldName: 'Condenser Water Inlet Node Name' },
      { portId: 'condenser-water-outlet', fieldIndex: 17, fieldName: 'Condenser Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-water-heating-desuperheater',
    idfClass: 'Coil:WaterHeating:Desuperheater',
    nameFieldIndex: 0,
    totalFields: 20,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 9, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 10, fieldName: 'Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-system-cooling-dx',
    idfClass: 'CoilSystem:Cooling:DX',
    nameFieldIndex: 0,
    totalFields: 12,
    fieldMappings: {},
    portMappings: [
      { portId: 'dx-cooling-coil-system-inlet', fieldIndex: 2, fieldName: 'DX Cooling Coil System Inlet Node Name' },
      { portId: 'dx-cooling-coil-system-outlet', fieldIndex: 3, fieldName: 'DX Cooling Coil System Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-cooling-dx-single-speed-thermal-storage',
    idfClass: 'Coil:Cooling:DX:SingleSpeed:ThermalStorage',
    nameFieldIndex: 0,
    totalFields: 106,
    fieldMappings: {},
    portMappings: [
      { portId: 'evaporator-air-inlet', fieldIndex: 13, fieldName: 'Evaporator Air Inlet Node Name' },
      { portId: 'evaporator-air-outlet', fieldIndex: 14, fieldName: 'Evaporator Air Outlet Node Name' },
      { portId: 'condenser-air-inlet', fieldIndex: 88, fieldName: 'Condenser Air Inlet Node Name' },
      { portId: 'condenser-air-outlet', fieldIndex: 89, fieldName: 'Condenser Air Outlet Node Name' },
      { portId: 'storage-tank-plant-connection-inlet', fieldIndex: 100, fieldName: 'Storage Tank Plant Connection Inlet Node Name' },
      { portId: 'storage-tank-plant-connection-outlet', fieldIndex: 101, fieldName: 'Storage Tank Plant Connection Outlet Node Name' },
    ],
  },
  {
    componentType: 'evaporative-cooler-direct-cel-dek-pad',
    idfClass: 'EvaporativeCooler:Direct:CelDekPad',
    nameFieldIndex: 0,
    totalFields: 9,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 5, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 6, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'evaporative-cooler-indirect-cel-dek-pad',
    idfClass: 'EvaporativeCooler:Indirect:CelDekPad',
    nameFieldIndex: 0,
    totalFields: 14,
    fieldMappings: {},
    portMappings: [
      { portId: 'primary-air-inlet', fieldIndex: 9, fieldName: 'Primary Air Inlet Node Name' },
      { portId: 'primary-air-outlet', fieldIndex: 10, fieldName: 'Primary Air Outlet Node Name' },
      { portId: 'secondary-air-inlet', fieldIndex: 13, fieldName: 'Secondary Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'evaporative-cooler-indirect-wet-coil',
    idfClass: 'EvaporativeCooler:Indirect:WetCoil',
    nameFieldIndex: 0,
    totalFields: 13,
    fieldMappings: {},
    portMappings: [
      { portId: 'primary-air-inlet', fieldIndex: 8, fieldName: 'Primary Air Inlet Node Name' },
      { portId: 'primary-air-outlet', fieldIndex: 9, fieldName: 'Primary Air Outlet Node Name' },
      { portId: 'secondary-air-inlet', fieldIndex: 12, fieldName: 'Secondary Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'evaporative-cooler-indirect-research-special',
    idfClass: 'EvaporativeCooler:Indirect:ResearchSpecial',
    nameFieldIndex: 0,
    totalFields: 28,
    fieldMappings: {},
    portMappings: [
      { portId: 'primary-air-inlet', fieldIndex: 14, fieldName: 'Primary Air Inlet Node Name' },
      { portId: 'primary-air-outlet', fieldIndex: 15, fieldName: 'Primary Air Outlet Node Name' },
      { portId: 'secondary-air-inlet', fieldIndex: 18, fieldName: 'Secondary Air Inlet Node Name' },
      { portId: 'secondary-air-outlet', fieldIndex: 19, fieldName: 'Secondary Air Outlet Node Name' },
      { portId: 'relief-air-inlet', fieldIndex: 21, fieldName: 'Relief Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'evaporative-cooler-direct-research-special',
    idfClass: 'EvaporativeCooler:Direct:ResearchSpecial',
    nameFieldIndex: 0,
    totalFields: 17,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 8, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 9, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'humidifier-steam-electric',
    idfClass: 'Humidifier:Steam:Electric',
    nameFieldIndex: 0,
    totalFields: 9,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 6, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 7, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'humidifier-steam-gas',
    idfClass: 'Humidifier:Steam:Gas',
    nameFieldIndex: 0,
    totalFields: 12,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 8, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 9, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'dehumidifier-desiccant-no-fans',
    idfClass: 'Dehumidifier:Desiccant:NoFans',
    nameFieldIndex: 0,
    totalFields: 25,
    fieldMappings: {},
    portMappings: [
      { portId: 'process-air-inlet', fieldIndex: 2, fieldName: 'Process Air Inlet Node Name' },
      { portId: 'process-air-outlet', fieldIndex: 3, fieldName: 'Process Air Outlet Node Name' },
      { portId: 'regeneration-air-inlet', fieldIndex: 4, fieldName: 'Regeneration Air Inlet Node Name' },
      { portId: 'regeneration-fan-inlet', fieldIndex: 5, fieldName: 'Regeneration Fan Inlet Node Name' },
    ],
  },
  {
    componentType: 'heat-exchanger-air-to-air-flat-plate',
    idfClass: 'HeatExchanger:AirToAir:FlatPlate',
    nameFieldIndex: 0,
    totalFields: 15,
    fieldMappings: {},
    portMappings: [
      { portId: 'supply-air-inlet', fieldIndex: 11, fieldName: 'Supply Air Inlet Node Name' },
      { portId: 'supply-air-outlet', fieldIndex: 12, fieldName: 'Supply Air Outlet Node Name' },
      { portId: 'secondary-air-inlet', fieldIndex: 13, fieldName: 'Secondary Air Inlet Node Name' },
      { portId: 'secondary-air-outlet', fieldIndex: 14, fieldName: 'Secondary Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'heat-exchanger-air-to-air-sensible-and-latent',
    idfClass: 'HeatExchanger:AirToAir:SensibleAndLatent',
    nameFieldIndex: 0,
    totalFields: 23,
    fieldMappings: {},
    portMappings: [
      { portId: 'supply-air-inlet', fieldIndex: 7, fieldName: 'Supply Air Inlet Node Name' },
      { portId: 'supply-air-outlet', fieldIndex: 8, fieldName: 'Supply Air Outlet Node Name' },
      { portId: 'exhaust-air-inlet', fieldIndex: 9, fieldName: 'Exhaust Air Inlet Node Name' },
      { portId: 'exhaust-air-outlet', fieldIndex: 10, fieldName: 'Exhaust Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'heat-exchanger-desiccant-balanced-flow',
    idfClass: 'HeatExchanger:Desiccant:BalancedFlow',
    nameFieldIndex: 0,
    totalFields: 9,
    fieldMappings: {},
    portMappings: [
      { portId: 'regeneration-air-inlet', fieldIndex: 2, fieldName: 'Regeneration Air Inlet Node Name' },
      { portId: 'regeneration-air-outlet', fieldIndex: 3, fieldName: 'Regeneration Air Outlet Node Name' },
      { portId: 'process-air-inlet', fieldIndex: 4, fieldName: 'Process Air Inlet Node Name' },
      { portId: 'process-air-outlet', fieldIndex: 5, fieldName: 'Process Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-unitary-system',
    idfClass: 'AirLoopHVAC:UnitarySystem',
    nameFieldIndex: 0,
    totalFields: 50,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 5, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 6, fieldName: 'Air Outlet Node Name' },
      { portId: 'heat-recovery-water-inlet', fieldIndex: 46, fieldName: 'Heat Recovery Water Inlet Node Name' },
      { portId: 'heat-recovery-water-outlet', fieldIndex: 47, fieldName: 'Heat Recovery Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-unitary-furnace-heat-only',
    idfClass: 'AirLoopHVAC:Unitary:Furnace:HeatOnly',
    nameFieldIndex: 0,
    totalFields: 13,
    fieldMappings: {},
    portMappings: [
      { portId: 'furnace-air-inlet', fieldIndex: 2, fieldName: 'Furnace Air Inlet Node Name' },
      { portId: 'furnace-air-outlet', fieldIndex: 3, fieldName: 'Furnace Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-unitary-furnace-heat-cool',
    idfClass: 'AirLoopHVAC:Unitary:Furnace:HeatCool',
    nameFieldIndex: 0,
    totalFields: 20,
    fieldMappings: {},
    portMappings: [
      { portId: 'furnace-air-inlet', fieldIndex: 2, fieldName: 'Furnace Air Inlet Node Name' },
      { portId: 'furnace-air-outlet', fieldIndex: 3, fieldName: 'Furnace Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-unitary-heat-only',
    idfClass: 'AirLoopHVAC:UnitaryHeatOnly',
    nameFieldIndex: 0,
    totalFields: 13,
    fieldMappings: {},
    portMappings: [
      { portId: 'unitary-system-air-inlet', fieldIndex: 2, fieldName: 'Unitary System Air Inlet Node Name' },
      { portId: 'unitary-system-air-outlet', fieldIndex: 3, fieldName: 'Unitary System Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-unitary-heat-cool',
    idfClass: 'AirLoopHVAC:UnitaryHeatCool',
    nameFieldIndex: 0,
    totalFields: 20,
    fieldMappings: {},
    portMappings: [
      { portId: 'unitary-system-air-inlet', fieldIndex: 2, fieldName: 'Unitary System Air Inlet Node Name' },
      { portId: 'unitary-system-air-outlet', fieldIndex: 3, fieldName: 'Unitary System Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-unitary-heat-pump-air-to-air',
    idfClass: 'AirLoopHVAC:UnitaryHeatPump:AirToAir',
    nameFieldIndex: 0,
    totalFields: 22,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 2, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 3, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-unitary-heat-pump-water-to-air',
    idfClass: 'AirLoopHVAC:UnitaryHeatPump:WaterToAir',
    nameFieldIndex: 0,
    totalFields: 24,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 2, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 3, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-unitary-heat-cool-vavchangeover-bypass',
    idfClass: 'AirLoopHVAC:UnitaryHeatCool:VAVChangeoverBypass',
    nameFieldIndex: 0,
    totalFields: 29,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 9, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 12, fieldName: 'Air Outlet Node Name' },
      { portId: 'plenum-or-mixer-inlet', fieldIndex: 27, fieldName: 'Plenum or Mixer Inlet Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-unitary-heat-pump-air-to-air-multi-speed',
    idfClass: 'AirLoopHVAC:UnitaryHeatPump:AirToAir:MultiSpeed',
    nameFieldIndex: 0,
    totalFields: 35,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 2, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 3, fieldName: 'Air Outlet Node Name' },
      { portId: 'heat-recovery-water-inlet', fieldIndex: 22, fieldName: 'Heat Recovery Water Inlet Node Name' },
      { portId: 'heat-recovery-water-outlet', fieldIndex: 23, fieldName: 'Heat Recovery Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-conditioner-variable-refrigerant-flow',
    idfClass: 'AirConditioner:VariableRefrigerantFlow',
    nameFieldIndex: 0,
    totalFields: 81,
    fieldMappings: {},
    portMappings: [
      { portId: 'condenser-inlet', fieldIndex: 56, fieldName: 'Condenser Inlet Node Name' },
      { portId: 'condenser-outlet', fieldIndex: 57, fieldName: 'Condenser Outlet Node Name' },
    ],
  },
  {
    componentType: 'controller-outdoor-air',
    idfClass: 'Controller:OutdoorAir',
    nameFieldIndex: 0,
    totalFields: 27,
    fieldMappings: {},
    portMappings: [
      { portId: 'relief-air-outlet', fieldIndex: 1, fieldName: 'Relief Air Outlet Node Name' },
      { portId: 'return-air', fieldIndex: 2, fieldName: 'Return Air Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac',
    idfClass: 'AirLoopHVAC',
    nameFieldIndex: 0,
    totalFields: 11,
    fieldMappings: {},
    portMappings: [
      { portId: 'supply-side-inlet', fieldIndex: 6, fieldName: 'Supply Side Inlet Node Name' },
      { portId: 'demand-side-outlet', fieldIndex: 7, fieldName: 'Demand Side Outlet Node Name' },
      { portId: 'demand-side-inlet-node-names', fieldIndex: 8, fieldName: 'Demand Side Inlet Node Names' },
      { portId: 'supply-side-outlet-node-names', fieldIndex: 9, fieldName: 'Supply Side Outlet Node Names' },
    ],
  },
  {
    componentType: 'outdoor-air-mixer',
    idfClass: 'OutdoorAir:Mixer',
    nameFieldIndex: 0,
    totalFields: 5,
    fieldMappings: {},
    portMappings: [
      { portId: 'return-air-stream', fieldIndex: 4, fieldName: 'Return Air Stream Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-zone-splitter',
    idfClass: 'AirLoopHVAC:ZoneSplitter',
    nameFieldIndex: 0,
    totalFields: 502,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet-1', fieldIndex: 2, fieldName: 'Outlet 1 Node Name' },
      { portId: 'outlet-2', fieldIndex: 3, fieldName: 'Outlet 2 Node Name' },
      { portId: 'outlet-3', fieldIndex: 4, fieldName: 'Outlet 3 Node Name' },
      { portId: 'outlet-4', fieldIndex: 5, fieldName: 'Outlet 4 Node Name' },
      { portId: 'outlet-5', fieldIndex: 6, fieldName: 'Outlet 5 Node Name' },
      { portId: 'outlet-6', fieldIndex: 7, fieldName: 'Outlet 6 Node Name' },
      { portId: 'outlet-7', fieldIndex: 8, fieldName: 'Outlet 7 Node Name' },
      { portId: 'outlet-8', fieldIndex: 9, fieldName: 'Outlet 8 Node Name' },
      { portId: 'outlet-9', fieldIndex: 10, fieldName: 'Outlet 9 Node Name' },
      { portId: 'outlet-10', fieldIndex: 11, fieldName: 'Outlet 10 Node Name' },
      { portId: 'outlet-11', fieldIndex: 12, fieldName: 'Outlet 11 Node Name' },
      { portId: 'outlet-12', fieldIndex: 13, fieldName: 'Outlet 12 Node Name' },
      { portId: 'outlet-13', fieldIndex: 14, fieldName: 'Outlet 13 Node Name' },
      { portId: 'outlet-14', fieldIndex: 15, fieldName: 'Outlet 14 Node Name' },
      { portId: 'outlet-15', fieldIndex: 16, fieldName: 'Outlet 15 Node Name' },
      { portId: 'outlet-16', fieldIndex: 17, fieldName: 'Outlet 16 Node Name' },
      { portId: 'outlet-17', fieldIndex: 18, fieldName: 'Outlet 17 Node Name' },
      { portId: 'outlet-18', fieldIndex: 19, fieldName: 'Outlet 18 Node Name' },
      { portId: 'outlet-19', fieldIndex: 20, fieldName: 'Outlet 19 Node Name' },
      { portId: 'outlet-20', fieldIndex: 21, fieldName: 'Outlet 20 Node Name' },
      { portId: 'outlet-21', fieldIndex: 22, fieldName: 'Outlet 21 Node Name' },
      { portId: 'outlet-22', fieldIndex: 23, fieldName: 'Outlet 22 Node Name' },
      { portId: 'outlet-23', fieldIndex: 24, fieldName: 'Outlet 23 Node Name' },
      { portId: 'outlet-24', fieldIndex: 25, fieldName: 'Outlet 24 Node Name' },
      { portId: 'outlet-25', fieldIndex: 26, fieldName: 'Outlet 25 Node Name' },
      { portId: 'outlet-26', fieldIndex: 27, fieldName: 'Outlet 26 Node Name' },
      { portId: 'outlet-27', fieldIndex: 28, fieldName: 'Outlet 27 Node Name' },
      { portId: 'outlet-28', fieldIndex: 29, fieldName: 'Outlet 28 Node Name' },
      { portId: 'outlet-29', fieldIndex: 30, fieldName: 'Outlet 29 Node Name' },
      { portId: 'outlet-30', fieldIndex: 31, fieldName: 'Outlet 30 Node Name' },
      { portId: 'outlet-31', fieldIndex: 32, fieldName: 'Outlet 31 Node Name' },
      { portId: 'outlet-32', fieldIndex: 33, fieldName: 'Outlet 32 Node Name' },
      { portId: 'outlet-33', fieldIndex: 34, fieldName: 'Outlet 33 Node Name' },
      { portId: 'outlet-34', fieldIndex: 35, fieldName: 'Outlet 34 Node Name' },
      { portId: 'outlet-35', fieldIndex: 36, fieldName: 'Outlet 35 Node Name' },
      { portId: 'outlet-36', fieldIndex: 37, fieldName: 'Outlet 36 Node Name' },
      { portId: 'outlet-37', fieldIndex: 38, fieldName: 'Outlet 37 Node Name' },
      { portId: 'outlet-38', fieldIndex: 39, fieldName: 'Outlet 38 Node Name' },
      { portId: 'outlet-39', fieldIndex: 40, fieldName: 'Outlet 39 Node Name' },
      { portId: 'outlet-40', fieldIndex: 41, fieldName: 'Outlet 40 Node Name' },
      { portId: 'outlet-41', fieldIndex: 42, fieldName: 'Outlet 41 Node Name' },
      { portId: 'outlet-42', fieldIndex: 43, fieldName: 'Outlet 42 Node Name' },
      { portId: 'outlet-43', fieldIndex: 44, fieldName: 'Outlet 43 Node Name' },
      { portId: 'outlet-44', fieldIndex: 45, fieldName: 'Outlet 44 Node Name' },
      { portId: 'outlet-45', fieldIndex: 46, fieldName: 'Outlet 45 Node Name' },
      { portId: 'outlet-46', fieldIndex: 47, fieldName: 'Outlet 46 Node Name' },
      { portId: 'outlet-47', fieldIndex: 48, fieldName: 'Outlet 47 Node Name' },
      { portId: 'outlet-48', fieldIndex: 49, fieldName: 'Outlet 48 Node Name' },
      { portId: 'outlet-49', fieldIndex: 50, fieldName: 'Outlet 49 Node Name' },
      { portId: 'outlet-50', fieldIndex: 51, fieldName: 'Outlet 50 Node Name' },
      { portId: 'outlet-51', fieldIndex: 52, fieldName: 'Outlet 51 Node Name' },
      { portId: 'outlet-52', fieldIndex: 53, fieldName: 'Outlet 52 Node Name' },
      { portId: 'outlet-53', fieldIndex: 54, fieldName: 'Outlet 53 Node Name' },
      { portId: 'outlet-54', fieldIndex: 55, fieldName: 'Outlet 54 Node Name' },
      { portId: 'outlet-55', fieldIndex: 56, fieldName: 'Outlet 55 Node Name' },
      { portId: 'outlet-56', fieldIndex: 57, fieldName: 'Outlet 56 Node Name' },
      { portId: 'outlet-57', fieldIndex: 58, fieldName: 'Outlet 57 Node Name' },
      { portId: 'outlet-58', fieldIndex: 59, fieldName: 'Outlet 58 Node Name' },
      { portId: 'outlet-59', fieldIndex: 60, fieldName: 'Outlet 59 Node Name' },
      { portId: 'outlet-60', fieldIndex: 61, fieldName: 'Outlet 60 Node Name' },
      { portId: 'outlet-61', fieldIndex: 62, fieldName: 'Outlet 61 Node Name' },
      { portId: 'outlet-62', fieldIndex: 63, fieldName: 'Outlet 62 Node Name' },
      { portId: 'outlet-63', fieldIndex: 64, fieldName: 'Outlet 63 Node Name' },
      { portId: 'outlet-64', fieldIndex: 65, fieldName: 'Outlet 64 Node Name' },
      { portId: 'outlet-65', fieldIndex: 66, fieldName: 'Outlet 65 Node Name' },
      { portId: 'outlet-66', fieldIndex: 67, fieldName: 'Outlet 66 Node Name' },
      { portId: 'outlet-67', fieldIndex: 68, fieldName: 'Outlet 67 Node Name' },
      { portId: 'outlet-68', fieldIndex: 69, fieldName: 'Outlet 68 Node Name' },
      { portId: 'outlet-69', fieldIndex: 70, fieldName: 'Outlet 69 Node Name' },
      { portId: 'outlet-70', fieldIndex: 71, fieldName: 'Outlet 70 Node Name' },
      { portId: 'outlet-71', fieldIndex: 72, fieldName: 'Outlet 71 Node Name' },
      { portId: 'outlet-72', fieldIndex: 73, fieldName: 'Outlet 72 Node Name' },
      { portId: 'outlet-73', fieldIndex: 74, fieldName: 'Outlet 73 Node Name' },
      { portId: 'outlet-74', fieldIndex: 75, fieldName: 'Outlet 74 Node Name' },
      { portId: 'outlet-75', fieldIndex: 76, fieldName: 'Outlet 75 Node Name' },
      { portId: 'outlet-76', fieldIndex: 77, fieldName: 'Outlet 76 Node Name' },
      { portId: 'outlet-77', fieldIndex: 78, fieldName: 'Outlet 77 Node Name' },
      { portId: 'outlet-78', fieldIndex: 79, fieldName: 'Outlet 78 Node Name' },
      { portId: 'outlet-79', fieldIndex: 80, fieldName: 'Outlet 79 Node Name' },
      { portId: 'outlet-80', fieldIndex: 81, fieldName: 'Outlet 80 Node Name' },
      { portId: 'outlet-81', fieldIndex: 82, fieldName: 'Outlet 81 Node Name' },
      { portId: 'outlet-82', fieldIndex: 83, fieldName: 'Outlet 82 Node Name' },
      { portId: 'outlet-83', fieldIndex: 84, fieldName: 'Outlet 83 Node Name' },
      { portId: 'outlet-84', fieldIndex: 85, fieldName: 'Outlet 84 Node Name' },
      { portId: 'outlet-85', fieldIndex: 86, fieldName: 'Outlet 85 Node Name' },
      { portId: 'outlet-86', fieldIndex: 87, fieldName: 'Outlet 86 Node Name' },
      { portId: 'outlet-87', fieldIndex: 88, fieldName: 'Outlet 87 Node Name' },
      { portId: 'outlet-88', fieldIndex: 89, fieldName: 'Outlet 88 Node Name' },
      { portId: 'outlet-89', fieldIndex: 90, fieldName: 'Outlet 89 Node Name' },
      { portId: 'outlet-90', fieldIndex: 91, fieldName: 'Outlet 90 Node Name' },
      { portId: 'outlet-91', fieldIndex: 92, fieldName: 'Outlet 91 Node Name' },
      { portId: 'outlet-92', fieldIndex: 93, fieldName: 'Outlet 92 Node Name' },
      { portId: 'outlet-93', fieldIndex: 94, fieldName: 'Outlet 93 Node Name' },
      { portId: 'outlet-94', fieldIndex: 95, fieldName: 'Outlet 94 Node Name' },
      { portId: 'outlet-95', fieldIndex: 96, fieldName: 'Outlet 95 Node Name' },
      { portId: 'outlet-96', fieldIndex: 97, fieldName: 'Outlet 96 Node Name' },
      { portId: 'outlet-97', fieldIndex: 98, fieldName: 'Outlet 97 Node Name' },
      { portId: 'outlet-98', fieldIndex: 99, fieldName: 'Outlet 98 Node Name' },
      { portId: 'outlet-99', fieldIndex: 100, fieldName: 'Outlet 99 Node Name' },
      { portId: 'outlet-100', fieldIndex: 101, fieldName: 'Outlet 100 Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-supply-plenum',
    idfClass: 'AirLoopHVAC:SupplyPlenum',
    nameFieldIndex: 0,
    totalFields: 504,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 3, fieldName: 'Inlet Node Name' },
      { portId: 'outlet-1', fieldIndex: 4, fieldName: 'Outlet 1 Node Name' },
      { portId: 'outlet-2', fieldIndex: 5, fieldName: 'Outlet 2 Node Name' },
      { portId: 'outlet-3', fieldIndex: 6, fieldName: 'Outlet 3 Node Name' },
      { portId: 'outlet-4', fieldIndex: 7, fieldName: 'Outlet 4 Node Name' },
      { portId: 'outlet-5', fieldIndex: 8, fieldName: 'Outlet 5 Node Name' },
      { portId: 'outlet-6', fieldIndex: 9, fieldName: 'Outlet 6 Node Name' },
      { portId: 'outlet-7', fieldIndex: 10, fieldName: 'Outlet 7 Node Name' },
      { portId: 'outlet-8', fieldIndex: 11, fieldName: 'Outlet 8 Node Name' },
      { portId: 'outlet-9', fieldIndex: 12, fieldName: 'Outlet 9 Node Name' },
      { portId: 'outlet-10', fieldIndex: 13, fieldName: 'Outlet 10 Node Name' },
      { portId: 'outlet-11', fieldIndex: 14, fieldName: 'Outlet 11 Node Name' },
      { portId: 'outlet-12', fieldIndex: 15, fieldName: 'Outlet 12 Node Name' },
      { portId: 'outlet-13', fieldIndex: 16, fieldName: 'Outlet 13 Node Name' },
      { portId: 'outlet-14', fieldIndex: 17, fieldName: 'Outlet 14 Node Name' },
      { portId: 'outlet-15', fieldIndex: 18, fieldName: 'Outlet 15 Node Name' },
      { portId: 'outlet-16', fieldIndex: 19, fieldName: 'Outlet 16 Node Name' },
      { portId: 'outlet-17', fieldIndex: 20, fieldName: 'Outlet 17 Node Name' },
      { portId: 'outlet-18', fieldIndex: 21, fieldName: 'Outlet 18 Node Name' },
      { portId: 'outlet-19', fieldIndex: 22, fieldName: 'Outlet 19 Node Name' },
      { portId: 'outlet-20', fieldIndex: 23, fieldName: 'Outlet 20 Node Name' },
      { portId: 'outlet-21', fieldIndex: 24, fieldName: 'Outlet 21 Node Name' },
      { portId: 'outlet-22', fieldIndex: 25, fieldName: 'Outlet 22 Node Name' },
      { portId: 'outlet-23', fieldIndex: 26, fieldName: 'Outlet 23 Node Name' },
      { portId: 'outlet-24', fieldIndex: 27, fieldName: 'Outlet 24 Node Name' },
      { portId: 'outlet-25', fieldIndex: 28, fieldName: 'Outlet 25 Node Name' },
      { portId: 'outlet-26', fieldIndex: 29, fieldName: 'Outlet 26 Node Name' },
      { portId: 'outlet-27', fieldIndex: 30, fieldName: 'Outlet 27 Node Name' },
      { portId: 'outlet-28', fieldIndex: 31, fieldName: 'Outlet 28 Node Name' },
      { portId: 'outlet-29', fieldIndex: 32, fieldName: 'Outlet 29 Node Name' },
      { portId: 'outlet-30', fieldIndex: 33, fieldName: 'Outlet 30 Node Name' },
      { portId: 'outlet-31', fieldIndex: 34, fieldName: 'Outlet 31 Node Name' },
      { portId: 'outlet-32', fieldIndex: 35, fieldName: 'Outlet 32 Node Name' },
      { portId: 'outlet-33', fieldIndex: 36, fieldName: 'Outlet 33 Node Name' },
      { portId: 'outlet-34', fieldIndex: 37, fieldName: 'Outlet 34 Node Name' },
      { portId: 'outlet-35', fieldIndex: 38, fieldName: 'Outlet 35 Node Name' },
      { portId: 'outlet-36', fieldIndex: 39, fieldName: 'Outlet 36 Node Name' },
      { portId: 'outlet-37', fieldIndex: 40, fieldName: 'Outlet 37 Node Name' },
      { portId: 'outlet-38', fieldIndex: 41, fieldName: 'Outlet 38 Node Name' },
      { portId: 'outlet-39', fieldIndex: 42, fieldName: 'Outlet 39 Node Name' },
      { portId: 'outlet-40', fieldIndex: 43, fieldName: 'Outlet 40 Node Name' },
      { portId: 'outlet-41', fieldIndex: 44, fieldName: 'Outlet 41 Node Name' },
      { portId: 'outlet-42', fieldIndex: 45, fieldName: 'Outlet 42 Node Name' },
      { portId: 'outlet-43', fieldIndex: 46, fieldName: 'Outlet 43 Node Name' },
      { portId: 'outlet-44', fieldIndex: 47, fieldName: 'Outlet 44 Node Name' },
      { portId: 'outlet-45', fieldIndex: 48, fieldName: 'Outlet 45 Node Name' },
      { portId: 'outlet-46', fieldIndex: 49, fieldName: 'Outlet 46 Node Name' },
      { portId: 'outlet-47', fieldIndex: 50, fieldName: 'Outlet 47 Node Name' },
      { portId: 'outlet-48', fieldIndex: 51, fieldName: 'Outlet 48 Node Name' },
      { portId: 'outlet-49', fieldIndex: 52, fieldName: 'Outlet 49 Node Name' },
      { portId: 'outlet-50', fieldIndex: 53, fieldName: 'Outlet 50 Node Name' },
      { portId: 'outlet-51', fieldIndex: 54, fieldName: 'Outlet 51 Node Name' },
      { portId: 'outlet-52', fieldIndex: 55, fieldName: 'Outlet 52 Node Name' },
      { portId: 'outlet-53', fieldIndex: 56, fieldName: 'Outlet 53 Node Name' },
      { portId: 'outlet-54', fieldIndex: 57, fieldName: 'Outlet 54 Node Name' },
      { portId: 'outlet-55', fieldIndex: 58, fieldName: 'Outlet 55 Node Name' },
      { portId: 'outlet-56', fieldIndex: 59, fieldName: 'Outlet 56 Node Name' },
      { portId: 'outlet-57', fieldIndex: 60, fieldName: 'Outlet 57 Node Name' },
      { portId: 'outlet-58', fieldIndex: 61, fieldName: 'Outlet 58 Node Name' },
      { portId: 'outlet-59', fieldIndex: 62, fieldName: 'Outlet 59 Node Name' },
      { portId: 'outlet-60', fieldIndex: 63, fieldName: 'Outlet 60 Node Name' },
      { portId: 'outlet-61', fieldIndex: 64, fieldName: 'Outlet 61 Node Name' },
      { portId: 'outlet-62', fieldIndex: 65, fieldName: 'Outlet 62 Node Name' },
      { portId: 'outlet-63', fieldIndex: 66, fieldName: 'Outlet 63 Node Name' },
      { portId: 'outlet-64', fieldIndex: 67, fieldName: 'Outlet 64 Node Name' },
      { portId: 'outlet-65', fieldIndex: 68, fieldName: 'Outlet 65 Node Name' },
      { portId: 'outlet-66', fieldIndex: 69, fieldName: 'Outlet 66 Node Name' },
      { portId: 'outlet-67', fieldIndex: 70, fieldName: 'Outlet 67 Node Name' },
      { portId: 'outlet-68', fieldIndex: 71, fieldName: 'Outlet 68 Node Name' },
      { portId: 'outlet-69', fieldIndex: 72, fieldName: 'Outlet 69 Node Name' },
      { portId: 'outlet-70', fieldIndex: 73, fieldName: 'Outlet 70 Node Name' },
      { portId: 'outlet-71', fieldIndex: 74, fieldName: 'Outlet 71 Node Name' },
      { portId: 'outlet-72', fieldIndex: 75, fieldName: 'Outlet 72 Node Name' },
      { portId: 'outlet-73', fieldIndex: 76, fieldName: 'Outlet 73 Node Name' },
      { portId: 'outlet-74', fieldIndex: 77, fieldName: 'Outlet 74 Node Name' },
      { portId: 'outlet-75', fieldIndex: 78, fieldName: 'Outlet 75 Node Name' },
      { portId: 'outlet-76', fieldIndex: 79, fieldName: 'Outlet 76 Node Name' },
      { portId: 'outlet-77', fieldIndex: 80, fieldName: 'Outlet 77 Node Name' },
      { portId: 'outlet-78', fieldIndex: 81, fieldName: 'Outlet 78 Node Name' },
      { portId: 'outlet-79', fieldIndex: 82, fieldName: 'Outlet 79 Node Name' },
      { portId: 'outlet-80', fieldIndex: 83, fieldName: 'Outlet 80 Node Name' },
      { portId: 'outlet-81', fieldIndex: 84, fieldName: 'Outlet 81 Node Name' },
      { portId: 'outlet-82', fieldIndex: 85, fieldName: 'Outlet 82 Node Name' },
      { portId: 'outlet-83', fieldIndex: 86, fieldName: 'Outlet 83 Node Name' },
      { portId: 'outlet-84', fieldIndex: 87, fieldName: 'Outlet 84 Node Name' },
      { portId: 'outlet-85', fieldIndex: 88, fieldName: 'Outlet 85 Node Name' },
      { portId: 'outlet-86', fieldIndex: 89, fieldName: 'Outlet 86 Node Name' },
      { portId: 'outlet-87', fieldIndex: 90, fieldName: 'Outlet 87 Node Name' },
      { portId: 'outlet-88', fieldIndex: 91, fieldName: 'Outlet 88 Node Name' },
      { portId: 'outlet-89', fieldIndex: 92, fieldName: 'Outlet 89 Node Name' },
      { portId: 'outlet-90', fieldIndex: 93, fieldName: 'Outlet 90 Node Name' },
      { portId: 'outlet-91', fieldIndex: 94, fieldName: 'Outlet 91 Node Name' },
      { portId: 'outlet-92', fieldIndex: 95, fieldName: 'Outlet 92 Node Name' },
      { portId: 'outlet-93', fieldIndex: 96, fieldName: 'Outlet 93 Node Name' },
      { portId: 'outlet-94', fieldIndex: 97, fieldName: 'Outlet 94 Node Name' },
      { portId: 'outlet-95', fieldIndex: 98, fieldName: 'Outlet 95 Node Name' },
      { portId: 'outlet-96', fieldIndex: 99, fieldName: 'Outlet 96 Node Name' },
      { portId: 'outlet-97', fieldIndex: 100, fieldName: 'Outlet 97 Node Name' },
      { portId: 'outlet-98', fieldIndex: 101, fieldName: 'Outlet 98 Node Name' },
      { portId: 'outlet-99', fieldIndex: 102, fieldName: 'Outlet 99 Node Name' },
      { portId: 'outlet-100', fieldIndex: 103, fieldName: 'Outlet 100 Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-supply-path',
    idfClass: 'AirLoopHVAC:SupplyPath',
    nameFieldIndex: 0,
    totalFields: 52,
    fieldMappings: {},
    portMappings: [
      { portId: 'supply-air-path-inlet', fieldIndex: 1, fieldName: 'Supply Air Path Inlet Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-zone-mixer',
    idfClass: 'AirLoopHVAC:ZoneMixer',
    nameFieldIndex: 0,
    totalFields: 502,
    fieldMappings: {},
    portMappings: [
      { portId: 'outlet', fieldIndex: 1, fieldName: 'Outlet Node Name' },
      { portId: 'inlet-1', fieldIndex: 2, fieldName: 'Inlet 1 Node Name' },
      { portId: 'inlet-2', fieldIndex: 3, fieldName: 'Inlet 2 Node Name' },
      { portId: 'inlet-3', fieldIndex: 4, fieldName: 'Inlet 3 Node Name' },
      { portId: 'inlet-4', fieldIndex: 5, fieldName: 'Inlet 4 Node Name' },
      { portId: 'inlet-5', fieldIndex: 6, fieldName: 'Inlet 5 Node Name' },
      { portId: 'inlet-6', fieldIndex: 7, fieldName: 'Inlet 6 Node Name' },
      { portId: 'inlet-7', fieldIndex: 8, fieldName: 'Inlet 7 Node Name' },
      { portId: 'inlet-8', fieldIndex: 9, fieldName: 'Inlet 8 Node Name' },
      { portId: 'inlet-9', fieldIndex: 10, fieldName: 'Inlet 9 Node Name' },
      { portId: 'inlet-10', fieldIndex: 11, fieldName: 'Inlet 10 Node Name' },
      { portId: 'inlet-11', fieldIndex: 12, fieldName: 'Inlet 11 Node Name' },
      { portId: 'inlet-12', fieldIndex: 13, fieldName: 'Inlet 12 Node Name' },
      { portId: 'inlet-13', fieldIndex: 14, fieldName: 'Inlet 13 Node Name' },
      { portId: 'inlet-14', fieldIndex: 15, fieldName: 'Inlet 14 Node Name' },
      { portId: 'inlet-15', fieldIndex: 16, fieldName: 'Inlet 15 Node Name' },
      { portId: 'inlet-16', fieldIndex: 17, fieldName: 'Inlet 16 Node Name' },
      { portId: 'inlet-17', fieldIndex: 18, fieldName: 'Inlet 17 Node Name' },
      { portId: 'inlet-18', fieldIndex: 19, fieldName: 'Inlet 18 Node Name' },
      { portId: 'inlet-19', fieldIndex: 20, fieldName: 'Inlet 19 Node Name' },
      { portId: 'inlet-20', fieldIndex: 21, fieldName: 'Inlet 20 Node Name' },
      { portId: 'inlet-21', fieldIndex: 22, fieldName: 'Inlet 21 Node Name' },
      { portId: 'inlet-22', fieldIndex: 23, fieldName: 'Inlet 22 Node Name' },
      { portId: 'inlet-23', fieldIndex: 24, fieldName: 'Inlet 23 Node Name' },
      { portId: 'inlet-24', fieldIndex: 25, fieldName: 'Inlet 24 Node Name' },
      { portId: 'inlet-25', fieldIndex: 26, fieldName: 'Inlet 25 Node Name' },
      { portId: 'inlet-26', fieldIndex: 27, fieldName: 'Inlet 26 Node Name' },
      { portId: 'inlet-27', fieldIndex: 28, fieldName: 'Inlet 27 Node Name' },
      { portId: 'inlet-28', fieldIndex: 29, fieldName: 'Inlet 28 Node Name' },
      { portId: 'inlet-29', fieldIndex: 30, fieldName: 'Inlet 29 Node Name' },
      { portId: 'inlet-30', fieldIndex: 31, fieldName: 'Inlet 30 Node Name' },
      { portId: 'inlet-31', fieldIndex: 32, fieldName: 'Inlet 31 Node Name' },
      { portId: 'inlet-32', fieldIndex: 33, fieldName: 'Inlet 32 Node Name' },
      { portId: 'inlet-33', fieldIndex: 34, fieldName: 'Inlet 33 Node Name' },
      { portId: 'inlet-34', fieldIndex: 35, fieldName: 'Inlet 34 Node Name' },
      { portId: 'inlet-35', fieldIndex: 36, fieldName: 'Inlet 35 Node Name' },
      { portId: 'inlet-36', fieldIndex: 37, fieldName: 'Inlet 36 Node Name' },
      { portId: 'inlet-37', fieldIndex: 38, fieldName: 'Inlet 37 Node Name' },
      { portId: 'inlet-38', fieldIndex: 39, fieldName: 'Inlet 38 Node Name' },
      { portId: 'inlet-39', fieldIndex: 40, fieldName: 'Inlet 39 Node Name' },
      { portId: 'inlet-40', fieldIndex: 41, fieldName: 'Inlet 40 Node Name' },
      { portId: 'inlet-41', fieldIndex: 42, fieldName: 'Inlet 41 Node Name' },
      { portId: 'inlet-42', fieldIndex: 43, fieldName: 'Inlet 42 Node Name' },
      { portId: 'inlet-43', fieldIndex: 44, fieldName: 'Inlet 43 Node Name' },
      { portId: 'inlet-44', fieldIndex: 45, fieldName: 'Inlet 44 Node Name' },
      { portId: 'inlet-45', fieldIndex: 46, fieldName: 'Inlet 45 Node Name' },
      { portId: 'inlet-46', fieldIndex: 47, fieldName: 'Inlet 46 Node Name' },
      { portId: 'inlet-47', fieldIndex: 48, fieldName: 'Inlet 47 Node Name' },
      { portId: 'inlet-48', fieldIndex: 49, fieldName: 'Inlet 48 Node Name' },
      { portId: 'inlet-49', fieldIndex: 50, fieldName: 'Inlet 49 Node Name' },
      { portId: 'inlet-50', fieldIndex: 51, fieldName: 'Inlet 50 Node Name' },
      { portId: 'inlet-51', fieldIndex: 52, fieldName: 'Inlet 51 Node Name' },
      { portId: 'inlet-52', fieldIndex: 53, fieldName: 'Inlet 52 Node Name' },
      { portId: 'inlet-53', fieldIndex: 54, fieldName: 'Inlet 53 Node Name' },
      { portId: 'inlet-54', fieldIndex: 55, fieldName: 'Inlet 54 Node Name' },
      { portId: 'inlet-55', fieldIndex: 56, fieldName: 'Inlet 55 Node Name' },
      { portId: 'inlet-56', fieldIndex: 57, fieldName: 'Inlet 56 Node Name' },
      { portId: 'inlet-57', fieldIndex: 58, fieldName: 'Inlet 57 Node Name' },
      { portId: 'inlet-58', fieldIndex: 59, fieldName: 'Inlet 58 Node Name' },
      { portId: 'inlet-59', fieldIndex: 60, fieldName: 'Inlet 59 Node Name' },
      { portId: 'inlet-60', fieldIndex: 61, fieldName: 'Inlet 60 Node Name' },
      { portId: 'inlet-61', fieldIndex: 62, fieldName: 'Inlet 61 Node Name' },
      { portId: 'inlet-62', fieldIndex: 63, fieldName: 'Inlet 62 Node Name' },
      { portId: 'inlet-63', fieldIndex: 64, fieldName: 'Inlet 63 Node Name' },
      { portId: 'inlet-64', fieldIndex: 65, fieldName: 'Inlet 64 Node Name' },
      { portId: 'inlet-65', fieldIndex: 66, fieldName: 'Inlet 65 Node Name' },
      { portId: 'inlet-66', fieldIndex: 67, fieldName: 'Inlet 66 Node Name' },
      { portId: 'inlet-67', fieldIndex: 68, fieldName: 'Inlet 67 Node Name' },
      { portId: 'inlet-68', fieldIndex: 69, fieldName: 'Inlet 68 Node Name' },
      { portId: 'inlet-69', fieldIndex: 70, fieldName: 'Inlet 69 Node Name' },
      { portId: 'inlet-70', fieldIndex: 71, fieldName: 'Inlet 70 Node Name' },
      { portId: 'inlet-71', fieldIndex: 72, fieldName: 'Inlet 71 Node Name' },
      { portId: 'inlet-72', fieldIndex: 73, fieldName: 'Inlet 72 Node Name' },
      { portId: 'inlet-73', fieldIndex: 74, fieldName: 'Inlet 73 Node Name' },
      { portId: 'inlet-74', fieldIndex: 75, fieldName: 'Inlet 74 Node Name' },
      { portId: 'inlet-75', fieldIndex: 76, fieldName: 'Inlet 75 Node Name' },
      { portId: 'inlet-76', fieldIndex: 77, fieldName: 'Inlet 76 Node Name' },
      { portId: 'inlet-77', fieldIndex: 78, fieldName: 'Inlet 77 Node Name' },
      { portId: 'inlet-78', fieldIndex: 79, fieldName: 'Inlet 78 Node Name' },
      { portId: 'inlet-79', fieldIndex: 80, fieldName: 'Inlet 79 Node Name' },
      { portId: 'inlet-80', fieldIndex: 81, fieldName: 'Inlet 80 Node Name' },
      { portId: 'inlet-81', fieldIndex: 82, fieldName: 'Inlet 81 Node Name' },
      { portId: 'inlet-82', fieldIndex: 83, fieldName: 'Inlet 82 Node Name' },
      { portId: 'inlet-83', fieldIndex: 84, fieldName: 'Inlet 83 Node Name' },
      { portId: 'inlet-84', fieldIndex: 85, fieldName: 'Inlet 84 Node Name' },
      { portId: 'inlet-85', fieldIndex: 86, fieldName: 'Inlet 85 Node Name' },
      { portId: 'inlet-86', fieldIndex: 87, fieldName: 'Inlet 86 Node Name' },
      { portId: 'inlet-87', fieldIndex: 88, fieldName: 'Inlet 87 Node Name' },
      { portId: 'inlet-88', fieldIndex: 89, fieldName: 'Inlet 88 Node Name' },
      { portId: 'inlet-89', fieldIndex: 90, fieldName: 'Inlet 89 Node Name' },
      { portId: 'inlet-90', fieldIndex: 91, fieldName: 'Inlet 90 Node Name' },
      { portId: 'inlet-91', fieldIndex: 92, fieldName: 'Inlet 91 Node Name' },
      { portId: 'inlet-92', fieldIndex: 93, fieldName: 'Inlet 92 Node Name' },
      { portId: 'inlet-93', fieldIndex: 94, fieldName: 'Inlet 93 Node Name' },
      { portId: 'inlet-94', fieldIndex: 95, fieldName: 'Inlet 94 Node Name' },
      { portId: 'inlet-95', fieldIndex: 96, fieldName: 'Inlet 95 Node Name' },
      { portId: 'inlet-96', fieldIndex: 97, fieldName: 'Inlet 96 Node Name' },
      { portId: 'inlet-97', fieldIndex: 98, fieldName: 'Inlet 97 Node Name' },
      { portId: 'inlet-98', fieldIndex: 99, fieldName: 'Inlet 98 Node Name' },
      { portId: 'inlet-99', fieldIndex: 100, fieldName: 'Inlet 99 Node Name' },
      { portId: 'inlet-100', fieldIndex: 101, fieldName: 'Inlet 100 Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-return-plenum',
    idfClass: 'AirLoopHVAC:ReturnPlenum',
    nameFieldIndex: 0,
    totalFields: 505,
    fieldMappings: {},
    portMappings: [
      { portId: 'outlet', fieldIndex: 3, fieldName: 'Outlet Node Name' },
      { portId: 'induced-air-outlet-node-or-nodelist-name', fieldIndex: 4, fieldName: 'Induced Air Outlet Node or NodeList Name' },
      { portId: 'inlet-1', fieldIndex: 5, fieldName: 'Inlet 1 Node Name' },
      { portId: 'inlet-2', fieldIndex: 6, fieldName: 'Inlet 2 Node Name' },
      { portId: 'inlet-3', fieldIndex: 7, fieldName: 'Inlet 3 Node Name' },
      { portId: 'inlet-4', fieldIndex: 8, fieldName: 'Inlet 4 Node Name' },
      { portId: 'inlet-5', fieldIndex: 9, fieldName: 'Inlet 5 Node Name' },
      { portId: 'inlet-6', fieldIndex: 10, fieldName: 'Inlet 6 Node Name' },
      { portId: 'inlet-7', fieldIndex: 11, fieldName: 'Inlet 7 Node Name' },
      { portId: 'inlet-8', fieldIndex: 12, fieldName: 'Inlet 8 Node Name' },
      { portId: 'inlet-9', fieldIndex: 13, fieldName: 'Inlet 9 Node Name' },
      { portId: 'inlet-10', fieldIndex: 14, fieldName: 'Inlet 10 Node Name' },
      { portId: 'inlet-11', fieldIndex: 15, fieldName: 'Inlet 11 Node Name' },
      { portId: 'inlet-12', fieldIndex: 16, fieldName: 'Inlet 12 Node Name' },
      { portId: 'inlet-13', fieldIndex: 17, fieldName: 'Inlet 13 Node Name' },
      { portId: 'inlet-14', fieldIndex: 18, fieldName: 'Inlet 14 Node Name' },
      { portId: 'inlet-15', fieldIndex: 19, fieldName: 'Inlet 15 Node Name' },
      { portId: 'inlet-16', fieldIndex: 20, fieldName: 'Inlet 16 Node Name' },
      { portId: 'inlet-17', fieldIndex: 21, fieldName: 'Inlet 17 Node Name' },
      { portId: 'inlet-18', fieldIndex: 22, fieldName: 'Inlet 18 Node Name' },
      { portId: 'inlet-19', fieldIndex: 23, fieldName: 'Inlet 19 Node Name' },
      { portId: 'inlet-20', fieldIndex: 24, fieldName: 'Inlet 20 Node Name' },
      { portId: 'inlet-21', fieldIndex: 25, fieldName: 'Inlet 21 Node Name' },
      { portId: 'inlet-22', fieldIndex: 26, fieldName: 'Inlet 22 Node Name' },
      { portId: 'inlet-23', fieldIndex: 27, fieldName: 'Inlet 23 Node Name' },
      { portId: 'inlet-24', fieldIndex: 28, fieldName: 'Inlet 24 Node Name' },
      { portId: 'inlet-25', fieldIndex: 29, fieldName: 'Inlet 25 Node Name' },
      { portId: 'inlet-26', fieldIndex: 30, fieldName: 'Inlet 26 Node Name' },
      { portId: 'inlet-27', fieldIndex: 31, fieldName: 'Inlet 27 Node Name' },
      { portId: 'inlet-28', fieldIndex: 32, fieldName: 'Inlet 28 Node Name' },
      { portId: 'inlet-29', fieldIndex: 33, fieldName: 'Inlet 29 Node Name' },
      { portId: 'inlet-30', fieldIndex: 34, fieldName: 'Inlet 30 Node Name' },
      { portId: 'inlet-31', fieldIndex: 35, fieldName: 'Inlet 31 Node Name' },
      { portId: 'inlet-32', fieldIndex: 36, fieldName: 'Inlet 32 Node Name' },
      { portId: 'inlet-33', fieldIndex: 37, fieldName: 'Inlet 33 Node Name' },
      { portId: 'inlet-34', fieldIndex: 38, fieldName: 'Inlet 34 Node Name' },
      { portId: 'inlet-35', fieldIndex: 39, fieldName: 'Inlet 35 Node Name' },
      { portId: 'inlet-36', fieldIndex: 40, fieldName: 'Inlet 36 Node Name' },
      { portId: 'inlet-37', fieldIndex: 41, fieldName: 'Inlet 37 Node Name' },
      { portId: 'inlet-38', fieldIndex: 42, fieldName: 'Inlet 38 Node Name' },
      { portId: 'inlet-39', fieldIndex: 43, fieldName: 'Inlet 39 Node Name' },
      { portId: 'inlet-40', fieldIndex: 44, fieldName: 'Inlet 40 Node Name' },
      { portId: 'inlet-41', fieldIndex: 45, fieldName: 'Inlet 41 Node Name' },
      { portId: 'inlet-42', fieldIndex: 46, fieldName: 'Inlet 42 Node Name' },
      { portId: 'inlet-43', fieldIndex: 47, fieldName: 'Inlet 43 Node Name' },
      { portId: 'inlet-44', fieldIndex: 48, fieldName: 'Inlet 44 Node Name' },
      { portId: 'inlet-45', fieldIndex: 49, fieldName: 'Inlet 45 Node Name' },
      { portId: 'inlet-46', fieldIndex: 50, fieldName: 'Inlet 46 Node Name' },
      { portId: 'inlet-47', fieldIndex: 51, fieldName: 'Inlet 47 Node Name' },
      { portId: 'inlet-48', fieldIndex: 52, fieldName: 'Inlet 48 Node Name' },
      { portId: 'inlet-49', fieldIndex: 53, fieldName: 'Inlet 49 Node Name' },
      { portId: 'inlet-50', fieldIndex: 54, fieldName: 'Inlet 50 Node Name' },
      { portId: 'inlet-51', fieldIndex: 55, fieldName: 'Inlet 51 Node Name' },
      { portId: 'inlet-52', fieldIndex: 56, fieldName: 'Inlet 52 Node Name' },
      { portId: 'inlet-53', fieldIndex: 57, fieldName: 'Inlet 53 Node Name' },
      { portId: 'inlet-54', fieldIndex: 58, fieldName: 'Inlet 54 Node Name' },
      { portId: 'inlet-55', fieldIndex: 59, fieldName: 'Inlet 55 Node Name' },
      { portId: 'inlet-56', fieldIndex: 60, fieldName: 'Inlet 56 Node Name' },
      { portId: 'inlet-57', fieldIndex: 61, fieldName: 'Inlet 57 Node Name' },
      { portId: 'inlet-58', fieldIndex: 62, fieldName: 'Inlet 58 Node Name' },
      { portId: 'inlet-59', fieldIndex: 63, fieldName: 'Inlet 59 Node Name' },
      { portId: 'inlet-60', fieldIndex: 64, fieldName: 'Inlet 60 Node Name' },
      { portId: 'inlet-61', fieldIndex: 65, fieldName: 'Inlet 61 Node Name' },
      { portId: 'inlet-62', fieldIndex: 66, fieldName: 'Inlet 62 Node Name' },
      { portId: 'inlet-63', fieldIndex: 67, fieldName: 'Inlet 63 Node Name' },
      { portId: 'inlet-64', fieldIndex: 68, fieldName: 'Inlet 64 Node Name' },
      { portId: 'inlet-65', fieldIndex: 69, fieldName: 'Inlet 65 Node Name' },
      { portId: 'inlet-66', fieldIndex: 70, fieldName: 'Inlet 66 Node Name' },
      { portId: 'inlet-67', fieldIndex: 71, fieldName: 'Inlet 67 Node Name' },
      { portId: 'inlet-68', fieldIndex: 72, fieldName: 'Inlet 68 Node Name' },
      { portId: 'inlet-69', fieldIndex: 73, fieldName: 'Inlet 69 Node Name' },
      { portId: 'inlet-70', fieldIndex: 74, fieldName: 'Inlet 70 Node Name' },
      { portId: 'inlet-71', fieldIndex: 75, fieldName: 'Inlet 71 Node Name' },
      { portId: 'inlet-72', fieldIndex: 76, fieldName: 'Inlet 72 Node Name' },
      { portId: 'inlet-73', fieldIndex: 77, fieldName: 'Inlet 73 Node Name' },
      { portId: 'inlet-74', fieldIndex: 78, fieldName: 'Inlet 74 Node Name' },
      { portId: 'inlet-75', fieldIndex: 79, fieldName: 'Inlet 75 Node Name' },
      { portId: 'inlet-76', fieldIndex: 80, fieldName: 'Inlet 76 Node Name' },
      { portId: 'inlet-77', fieldIndex: 81, fieldName: 'Inlet 77 Node Name' },
      { portId: 'inlet-78', fieldIndex: 82, fieldName: 'Inlet 78 Node Name' },
      { portId: 'inlet-79', fieldIndex: 83, fieldName: 'Inlet 79 Node Name' },
      { portId: 'inlet-80', fieldIndex: 84, fieldName: 'Inlet 80 Node Name' },
      { portId: 'inlet-81', fieldIndex: 85, fieldName: 'Inlet 81 Node Name' },
      { portId: 'inlet-82', fieldIndex: 86, fieldName: 'Inlet 82 Node Name' },
      { portId: 'inlet-83', fieldIndex: 87, fieldName: 'Inlet 83 Node Name' },
      { portId: 'inlet-84', fieldIndex: 88, fieldName: 'Inlet 84 Node Name' },
      { portId: 'inlet-85', fieldIndex: 89, fieldName: 'Inlet 85 Node Name' },
      { portId: 'inlet-86', fieldIndex: 90, fieldName: 'Inlet 86 Node Name' },
      { portId: 'inlet-87', fieldIndex: 91, fieldName: 'Inlet 87 Node Name' },
      { portId: 'inlet-88', fieldIndex: 92, fieldName: 'Inlet 88 Node Name' },
      { portId: 'inlet-89', fieldIndex: 93, fieldName: 'Inlet 89 Node Name' },
      { portId: 'inlet-90', fieldIndex: 94, fieldName: 'Inlet 90 Node Name' },
      { portId: 'inlet-91', fieldIndex: 95, fieldName: 'Inlet 91 Node Name' },
      { portId: 'inlet-92', fieldIndex: 96, fieldName: 'Inlet 92 Node Name' },
      { portId: 'inlet-93', fieldIndex: 97, fieldName: 'Inlet 93 Node Name' },
      { portId: 'inlet-94', fieldIndex: 98, fieldName: 'Inlet 94 Node Name' },
      { portId: 'inlet-95', fieldIndex: 99, fieldName: 'Inlet 95 Node Name' },
      { portId: 'inlet-96', fieldIndex: 100, fieldName: 'Inlet 96 Node Name' },
      { portId: 'inlet-97', fieldIndex: 101, fieldName: 'Inlet 97 Node Name' },
      { portId: 'inlet-98', fieldIndex: 102, fieldName: 'Inlet 98 Node Name' },
      { portId: 'inlet-99', fieldIndex: 103, fieldName: 'Inlet 99 Node Name' },
      { portId: 'inlet-100', fieldIndex: 104, fieldName: 'Inlet 100 Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-return-path',
    idfClass: 'AirLoopHVAC:ReturnPath',
    nameFieldIndex: 0,
    totalFields: 52,
    fieldMappings: {},
    portMappings: [
      { portId: 'return-air-path-outlet', fieldIndex: 1, fieldName: 'Return Air Path Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-mixer',
    idfClass: 'AirLoopHVAC:Mixer',
    nameFieldIndex: 0,
    totalFields: 52,
    fieldMappings: {},
    portMappings: [
      { portId: 'outlet', fieldIndex: 1, fieldName: 'Outlet Node Name' },
      { portId: 'inlet-1', fieldIndex: 2, fieldName: 'Inlet 1 Node Name' },
      { portId: 'inlet-2', fieldIndex: 3, fieldName: 'Inlet 2 Node Name' },
      { portId: 'inlet-3', fieldIndex: 4, fieldName: 'Inlet 3 Node Name' },
      { portId: 'inlet-4', fieldIndex: 5, fieldName: 'Inlet 4 Node Name' },
      { portId: 'inlet-5', fieldIndex: 6, fieldName: 'Inlet 5 Node Name' },
      { portId: 'inlet-6', fieldIndex: 7, fieldName: 'Inlet 6 Node Name' },
      { portId: 'inlet-7', fieldIndex: 8, fieldName: 'Inlet 7 Node Name' },
      { portId: 'inlet-8', fieldIndex: 9, fieldName: 'Inlet 8 Node Name' },
      { portId: 'inlet-9', fieldIndex: 10, fieldName: 'Inlet 9 Node Name' },
      { portId: 'inlet-10', fieldIndex: 11, fieldName: 'Inlet 10 Node Name' },
      { portId: 'inlet-11', fieldIndex: 12, fieldName: 'Inlet 11 Node Name' },
      { portId: 'inlet-12', fieldIndex: 13, fieldName: 'Inlet 12 Node Name' },
      { portId: 'inlet-13', fieldIndex: 14, fieldName: 'Inlet 13 Node Name' },
      { portId: 'inlet-14', fieldIndex: 15, fieldName: 'Inlet 14 Node Name' },
      { portId: 'inlet-15', fieldIndex: 16, fieldName: 'Inlet 15 Node Name' },
      { portId: 'inlet-16', fieldIndex: 17, fieldName: 'Inlet 16 Node Name' },
      { portId: 'inlet-17', fieldIndex: 18, fieldName: 'Inlet 17 Node Name' },
      { portId: 'inlet-18', fieldIndex: 19, fieldName: 'Inlet 18 Node Name' },
      { portId: 'inlet-19', fieldIndex: 20, fieldName: 'Inlet 19 Node Name' },
      { portId: 'inlet-20', fieldIndex: 21, fieldName: 'Inlet 20 Node Name' },
      { portId: 'inlet-21', fieldIndex: 22, fieldName: 'Inlet 21 Node Name' },
      { portId: 'inlet-22', fieldIndex: 23, fieldName: 'Inlet 22 Node Name' },
      { portId: 'inlet-23', fieldIndex: 24, fieldName: 'Inlet 23 Node Name' },
      { portId: 'inlet-24', fieldIndex: 25, fieldName: 'Inlet 24 Node Name' },
      { portId: 'inlet-25', fieldIndex: 26, fieldName: 'Inlet 25 Node Name' },
      { portId: 'inlet-26', fieldIndex: 27, fieldName: 'Inlet 26 Node Name' },
      { portId: 'inlet-27', fieldIndex: 28, fieldName: 'Inlet 27 Node Name' },
      { portId: 'inlet-28', fieldIndex: 29, fieldName: 'Inlet 28 Node Name' },
      { portId: 'inlet-29', fieldIndex: 30, fieldName: 'Inlet 29 Node Name' },
      { portId: 'inlet-30', fieldIndex: 31, fieldName: 'Inlet 30 Node Name' },
      { portId: 'inlet-31', fieldIndex: 32, fieldName: 'Inlet 31 Node Name' },
      { portId: 'inlet-32', fieldIndex: 33, fieldName: 'Inlet 32 Node Name' },
      { portId: 'inlet-33', fieldIndex: 34, fieldName: 'Inlet 33 Node Name' },
      { portId: 'inlet-34', fieldIndex: 35, fieldName: 'Inlet 34 Node Name' },
      { portId: 'inlet-35', fieldIndex: 36, fieldName: 'Inlet 35 Node Name' },
      { portId: 'inlet-36', fieldIndex: 37, fieldName: 'Inlet 36 Node Name' },
      { portId: 'inlet-37', fieldIndex: 38, fieldName: 'Inlet 37 Node Name' },
      { portId: 'inlet-38', fieldIndex: 39, fieldName: 'Inlet 38 Node Name' },
      { portId: 'inlet-39', fieldIndex: 40, fieldName: 'Inlet 39 Node Name' },
      { portId: 'inlet-40', fieldIndex: 41, fieldName: 'Inlet 40 Node Name' },
      { portId: 'inlet-41', fieldIndex: 42, fieldName: 'Inlet 41 Node Name' },
      { portId: 'inlet-42', fieldIndex: 43, fieldName: 'Inlet 42 Node Name' },
      { portId: 'inlet-43', fieldIndex: 44, fieldName: 'Inlet 43 Node Name' },
      { portId: 'inlet-44', fieldIndex: 45, fieldName: 'Inlet 44 Node Name' },
      { portId: 'inlet-45', fieldIndex: 46, fieldName: 'Inlet 45 Node Name' },
      { portId: 'inlet-46', fieldIndex: 47, fieldName: 'Inlet 46 Node Name' },
      { portId: 'inlet-47', fieldIndex: 48, fieldName: 'Inlet 47 Node Name' },
      { portId: 'inlet-48', fieldIndex: 49, fieldName: 'Inlet 48 Node Name' },
      { portId: 'inlet-49', fieldIndex: 50, fieldName: 'Inlet 49 Node Name' },
      { portId: 'inlet-50', fieldIndex: 51, fieldName: 'Inlet 50 Node Name' },
    ],
  },
  {
    componentType: 'air-loop-hvac-splitter',
    idfClass: 'AirLoopHVAC:Splitter',
    nameFieldIndex: 0,
    totalFields: 52,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet-1', fieldIndex: 2, fieldName: 'Outlet 1 Node Name' },
      { portId: 'outlet-2', fieldIndex: 3, fieldName: 'Outlet 2 Node Name' },
      { portId: 'outlet-3', fieldIndex: 4, fieldName: 'Outlet 3 Node Name' },
      { portId: 'outlet-4', fieldIndex: 5, fieldName: 'Outlet 4 Node Name' },
      { portId: 'outlet-5', fieldIndex: 6, fieldName: 'Outlet 5 Node Name' },
      { portId: 'outlet-6', fieldIndex: 7, fieldName: 'Outlet 6 Node Name' },
      { portId: 'outlet-7', fieldIndex: 8, fieldName: 'Outlet 7 Node Name' },
      { portId: 'outlet-8', fieldIndex: 9, fieldName: 'Outlet 8 Node Name' },
      { portId: 'outlet-9', fieldIndex: 10, fieldName: 'Outlet 9 Node Name' },
      { portId: 'outlet-10', fieldIndex: 11, fieldName: 'Outlet 10 Node Name' },
      { portId: 'outlet-11', fieldIndex: 12, fieldName: 'Outlet 11 Node Name' },
      { portId: 'outlet-12', fieldIndex: 13, fieldName: 'Outlet 12 Node Name' },
      { portId: 'outlet-13', fieldIndex: 14, fieldName: 'Outlet 13 Node Name' },
      { portId: 'outlet-14', fieldIndex: 15, fieldName: 'Outlet 14 Node Name' },
      { portId: 'outlet-15', fieldIndex: 16, fieldName: 'Outlet 15 Node Name' },
      { portId: 'outlet-16', fieldIndex: 17, fieldName: 'Outlet 16 Node Name' },
      { portId: 'outlet-17', fieldIndex: 18, fieldName: 'Outlet 17 Node Name' },
      { portId: 'outlet-18', fieldIndex: 19, fieldName: 'Outlet 18 Node Name' },
      { portId: 'outlet-19', fieldIndex: 20, fieldName: 'Outlet 19 Node Name' },
      { portId: 'outlet-20', fieldIndex: 21, fieldName: 'Outlet 20 Node Name' },
      { portId: 'outlet-21', fieldIndex: 22, fieldName: 'Outlet 21 Node Name' },
      { portId: 'outlet-22', fieldIndex: 23, fieldName: 'Outlet 22 Node Name' },
      { portId: 'outlet-23', fieldIndex: 24, fieldName: 'Outlet 23 Node Name' },
      { portId: 'outlet-24', fieldIndex: 25, fieldName: 'Outlet 24 Node Name' },
      { portId: 'outlet-25', fieldIndex: 26, fieldName: 'Outlet 25 Node Name' },
      { portId: 'outlet-26', fieldIndex: 27, fieldName: 'Outlet 26 Node Name' },
      { portId: 'outlet-27', fieldIndex: 28, fieldName: 'Outlet 27 Node Name' },
      { portId: 'outlet-28', fieldIndex: 29, fieldName: 'Outlet 28 Node Name' },
      { portId: 'outlet-29', fieldIndex: 30, fieldName: 'Outlet 29 Node Name' },
      { portId: 'outlet-30', fieldIndex: 31, fieldName: 'Outlet 30 Node Name' },
      { portId: 'outlet-31', fieldIndex: 32, fieldName: 'Outlet 31 Node Name' },
      { portId: 'outlet-32', fieldIndex: 33, fieldName: 'Outlet 32 Node Name' },
      { portId: 'outlet-33', fieldIndex: 34, fieldName: 'Outlet 33 Node Name' },
      { portId: 'outlet-34', fieldIndex: 35, fieldName: 'Outlet 34 Node Name' },
      { portId: 'outlet-35', fieldIndex: 36, fieldName: 'Outlet 35 Node Name' },
      { portId: 'outlet-36', fieldIndex: 37, fieldName: 'Outlet 36 Node Name' },
      { portId: 'outlet-37', fieldIndex: 38, fieldName: 'Outlet 37 Node Name' },
      { portId: 'outlet-38', fieldIndex: 39, fieldName: 'Outlet 38 Node Name' },
      { portId: 'outlet-39', fieldIndex: 40, fieldName: 'Outlet 39 Node Name' },
      { portId: 'outlet-40', fieldIndex: 41, fieldName: 'Outlet 40 Node Name' },
      { portId: 'outlet-41', fieldIndex: 42, fieldName: 'Outlet 41 Node Name' },
      { portId: 'outlet-42', fieldIndex: 43, fieldName: 'Outlet 42 Node Name' },
      { portId: 'outlet-43', fieldIndex: 44, fieldName: 'Outlet 43 Node Name' },
      { portId: 'outlet-44', fieldIndex: 45, fieldName: 'Outlet 44 Node Name' },
      { portId: 'outlet-45', fieldIndex: 46, fieldName: 'Outlet 45 Node Name' },
      { portId: 'outlet-46', fieldIndex: 47, fieldName: 'Outlet 46 Node Name' },
      { portId: 'outlet-47', fieldIndex: 48, fieldName: 'Outlet 47 Node Name' },
      { portId: 'outlet-48', fieldIndex: 49, fieldName: 'Outlet 48 Node Name' },
      { portId: 'outlet-49', fieldIndex: 50, fieldName: 'Outlet 49 Node Name' },
      { portId: 'outlet-50', fieldIndex: 51, fieldName: 'Outlet 50 Node Name' },
    ],
  },
  {
    componentType: 'branch',
    idfClass: 'Branch',
    nameFieldIndex: 0,
    totalFields: 46,
    fieldMappings: {},
    portMappings: [
      { portId: 'component-1-inlet', fieldIndex: 4, fieldName: 'Component 1 Inlet Node Name' },
      { portId: 'component-1-outlet', fieldIndex: 5, fieldName: 'Component 1 Outlet Node Name' },
      { portId: 'component-2-inlet', fieldIndex: 8, fieldName: 'Component 2 Inlet Node Name' },
      { portId: 'component-2-outlet', fieldIndex: 9, fieldName: 'Component 2 Outlet Node Name' },
      { portId: 'component-3-inlet', fieldIndex: 12, fieldName: 'Component 3 Inlet Node Name' },
      { portId: 'component-3-outlet', fieldIndex: 13, fieldName: 'Component 3 Outlet Node Name' },
      { portId: 'component-4-inlet', fieldIndex: 16, fieldName: 'Component 4 Inlet Node Name' },
      { portId: 'component-4-outlet', fieldIndex: 17, fieldName: 'Component 4 Outlet Node Name' },
      { portId: 'component-5-inlet', fieldIndex: 20, fieldName: 'Component 5 Inlet Node Name' },
      { portId: 'component-5-outlet', fieldIndex: 21, fieldName: 'Component 5 Outlet Node Name' },
      { portId: 'component-6-inlet', fieldIndex: 24, fieldName: 'Component 6 Inlet Node Name' },
      { portId: 'component-6-outlet', fieldIndex: 25, fieldName: 'Component 6 Outlet Node Name' },
      { portId: 'component-7-inlet', fieldIndex: 28, fieldName: 'Component 7 Inlet Node Name' },
      { portId: 'component-7-outlet', fieldIndex: 29, fieldName: 'Component 7 Outlet Node Name' },
      { portId: 'component-8-inlet', fieldIndex: 32, fieldName: 'Component 8 Inlet Node Name' },
      { portId: 'component-8-outlet', fieldIndex: 33, fieldName: 'Component 8 Outlet Node Name' },
      { portId: 'component-9-inlet', fieldIndex: 36, fieldName: 'Component 9 Inlet Node Name' },
      { portId: 'component-9-outlet', fieldIndex: 37, fieldName: 'Component 9 Outlet Node Name' },
      { portId: 'component-10-inlet', fieldIndex: 40, fieldName: 'Component 10 Inlet Node Name' },
      { portId: 'component-10-outlet', fieldIndex: 41, fieldName: 'Component 10 Outlet Node Name' },
      { portId: 'component-11-inlet', fieldIndex: 44, fieldName: 'Component 11 Inlet Node Name' },
      { portId: 'component-11-outlet', fieldIndex: 45, fieldName: 'Component 11 Outlet Node Name' },
    ],
  },
  {
    componentType: 'pipe-adiabatic',
    idfClass: 'Pipe:Adiabatic',
    nameFieldIndex: 0,
    totalFields: 3,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 2, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'pipe-adiabatic-steam',
    idfClass: 'Pipe:Adiabatic:Steam',
    nameFieldIndex: 0,
    totalFields: 3,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 2, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'pipe-indoor',
    idfClass: 'Pipe:Indoor',
    nameFieldIndex: 0,
    totalFields: 10,
    fieldMappings: {},
    portMappings: [
      { portId: 'fluid-inlet', fieldIndex: 2, fieldName: 'Fluid Inlet Node Name' },
      { portId: 'fluid-outlet', fieldIndex: 3, fieldName: 'Fluid Outlet Node Name' },
    ],
  },
  {
    componentType: 'pipe-outdoor',
    idfClass: 'Pipe:Outdoor',
    nameFieldIndex: 0,
    totalFields: 7,
    fieldMappings: {},
    portMappings: [
      { portId: 'fluid-inlet', fieldIndex: 2, fieldName: 'Fluid Inlet Node Name' },
      { portId: 'fluid-outlet', fieldIndex: 3, fieldName: 'Fluid Outlet Node Name' },
    ],
  },
  {
    componentType: 'pipe-underground',
    idfClass: 'Pipe:Underground',
    nameFieldIndex: 0,
    totalFields: 10,
    fieldMappings: {},
    portMappings: [
      { portId: 'fluid-inlet', fieldIndex: 2, fieldName: 'Fluid Inlet Node Name' },
      { portId: 'fluid-outlet', fieldIndex: 3, fieldName: 'Fluid Outlet Node Name' },
    ],
  },
  {
    componentType: 'piping-system-underground-pipe-circuit',
    idfClass: 'PipingSystem:Underground:PipeCircuit',
    nameFieldIndex: 0,
    totalFields: 20,
    fieldMappings: {},
    portMappings: [
      { portId: 'circuit-inlet-node', fieldIndex: 7, fieldName: 'Circuit Inlet Node' },
      { portId: 'circuit-outlet-node', fieldIndex: 8, fieldName: 'Circuit Outlet Node' },
    ],
  },
  {
    componentType: 'duct',
    idfClass: 'Duct',
    nameFieldIndex: 0,
    totalFields: 3,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 2, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'pump-variable-speed',
    idfClass: 'Pump:VariableSpeed',
    nameFieldIndex: 0,
    totalFields: 30,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 2, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'pump-constant-speed',
    idfClass: 'Pump:ConstantSpeed',
    nameFieldIndex: 0,
    totalFields: 19,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 2, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'pump-variable-speed-condensate',
    idfClass: 'Pump:VariableSpeed:Condensate',
    nameFieldIndex: 0,
    totalFields: 19,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 2, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'headered-pumps-constant-speed',
    idfClass: 'HeaderedPumps:ConstantSpeed',
    nameFieldIndex: 0,
    totalFields: 18,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 2, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'headered-pumps-variable-speed',
    idfClass: 'HeaderedPumps:VariableSpeed',
    nameFieldIndex: 0,
    totalFields: 23,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 2, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'tempering-valve',
    idfClass: 'TemperingValve',
    nameFieldIndex: 0,
    totalFields: 6,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 2, fieldName: 'Outlet Node Name' },
      { portId: 'pump-outlet', fieldIndex: 5, fieldName: 'Pump Outlet Node Name' },
    ],
  },
  {
    componentType: 'load-profile-plant',
    idfClass: 'LoadProfile:Plant',
    nameFieldIndex: 0,
    totalFields: 9,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 2, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'solar-collector-flat-plate-water',
    idfClass: 'SolarCollector:FlatPlate:Water',
    nameFieldIndex: 0,
    totalFields: 6,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 3, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 4, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'solar-collector-flat-plate-photovoltaic-thermal',
    idfClass: 'SolarCollector:FlatPlate:PhotovoltaicThermal',
    nameFieldIndex: 0,
    totalFields: 10,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 5, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 6, fieldName: 'Water Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 7, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 8, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'solar-collector-integral-collector-storage',
    idfClass: 'SolarCollector:IntegralCollectorStorage',
    nameFieldIndex: 0,
    totalFields: 8,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 5, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 6, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'solar-collector-unglazed-transpired',
    idfClass: 'SolarCollector:UnglazedTranspired',
    nameFieldIndex: 0,
    totalFields: 32,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 3, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 4, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'solar-collector-unglazed-transpired-multisystem',
    idfClass: 'SolarCollector:UnglazedTranspired:Multisystem',
    nameFieldIndex: 0,
    totalFields: 21,
    fieldMappings: {},
    portMappings: [
      { portId: 'outdoor-air-system-1-collector-inlet-node', fieldIndex: 1, fieldName: 'Outdoor Air System 1 Collector Inlet Node' },
      { portId: 'outdoor-air-system-1-collector-outlet-node', fieldIndex: 2, fieldName: 'Outdoor Air System 1 Collector Outlet Node' },
      { portId: 'outdoor-air-system-2-collector-inlet-node', fieldIndex: 5, fieldName: 'Outdoor Air System 2 Collector Inlet Node' },
      { portId: 'outdoor-air-system-2-collector-outlet-node', fieldIndex: 6, fieldName: 'Outdoor Air System 2 Collector Outlet Node' },
      { portId: 'outdoor-air-system-3-collector-inlet-node', fieldIndex: 9, fieldName: 'Outdoor Air System 3 Collector Inlet Node' },
      { portId: 'outdoor-air-system-3-collector-outlet-node', fieldIndex: 10, fieldName: 'Outdoor Air System 3 Collector Outlet Node' },
      { portId: 'outdoor-air-system-4-collector-inlet-node', fieldIndex: 13, fieldName: 'Outdoor Air System 4 Collector Inlet Node' },
      { portId: 'outdoor-air-system-4-collector-outlet-node', fieldIndex: 14, fieldName: 'Outdoor Air System 4 Collector Outlet Node' },
      { portId: 'outdoor-air-system-5-collector-inlet-node', fieldIndex: 17, fieldName: 'Outdoor Air System 5 Collector Inlet Node' },
      { portId: 'outdoor-air-system-5-collector-outlet-node', fieldIndex: 18, fieldName: 'Outdoor Air System 5 Collector Outlet Node' },
    ],
  },
  {
    componentType: 'boiler-hot-water',
    idfClass: 'Boiler:HotWater',
    nameFieldIndex: 0,
    totalFields: 18,
    fieldMappings: {},
    portMappings: [
      { portId: 'boiler-water-inlet', fieldIndex: 10, fieldName: 'Boiler Water Inlet Node Name' },
      { portId: 'boiler-water-outlet', fieldIndex: 11, fieldName: 'Boiler Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'boiler-steam',
    idfClass: 'Boiler:Steam',
    nameFieldIndex: 0,
    totalFields: 16,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 12, fieldName: 'Water Inlet Node Name' },
      { portId: 'steam-outlet', fieldIndex: 13, fieldName: 'Steam Outlet Node Name' },
    ],
  },
  {
    componentType: 'chiller-electric-ashrae205',
    idfClass: 'Chiller:Electric:ASHRAE205',
    nameFieldIndex: 0,
    totalFields: 25,
    fieldMappings: {},
    portMappings: [
      { portId: 'chilled-water-inlet', fieldIndex: 9, fieldName: 'Chilled Water Inlet Node Name' },
      { portId: 'chilled-water-outlet', fieldIndex: 10, fieldName: 'Chilled Water Outlet Node Name' },
      { portId: 'condenser-inlet', fieldIndex: 12, fieldName: 'Condenser Inlet Node Name' },
      { portId: 'condenser-outlet', fieldIndex: 13, fieldName: 'Condenser Outlet Node Name' },
      { portId: 'oil-cooler-inlet', fieldIndex: 16, fieldName: 'Oil Cooler Inlet Node Name' },
      { portId: 'oil-cooler-outlet', fieldIndex: 17, fieldName: 'Oil Cooler Outlet Node Name' },
      { portId: 'auxiliary-inlet', fieldIndex: 19, fieldName: 'Auxiliary Inlet Node Name' },
      { portId: 'auxiliary-outlet', fieldIndex: 20, fieldName: 'Auxiliary Outlet Node Name' },
      { portId: 'heat-recovery-inlet', fieldIndex: 22, fieldName: 'Heat Recovery Inlet Node Name' },
      { portId: 'heat-recovery-outlet', fieldIndex: 23, fieldName: 'Heat Recovery Outlet Node Name' },
    ],
  },
  {
    componentType: 'chiller-electric-eir',
    idfClass: 'Chiller:Electric:EIR',
    nameFieldIndex: 0,
    totalFields: 40,
    fieldMappings: {},
    portMappings: [
      { portId: 'chilled-water-inlet', fieldIndex: 14, fieldName: 'Chilled Water Inlet Node Name' },
      { portId: 'chilled-water-outlet', fieldIndex: 15, fieldName: 'Chilled Water Outlet Node Name' },
      { portId: 'condenser-inlet', fieldIndex: 16, fieldName: 'Condenser Inlet Node Name' },
      { portId: 'condenser-outlet', fieldIndex: 17, fieldName: 'Condenser Outlet Node Name' },
      { portId: 'heat-recovery-inlet', fieldIndex: 24, fieldName: 'Heat Recovery Inlet Node Name' },
      { portId: 'heat-recovery-outlet', fieldIndex: 25, fieldName: 'Heat Recovery Outlet Node Name' },
      { portId: 'heat-recovery-leaving-temperature-setpoint', fieldIndex: 32, fieldName: 'Heat Recovery Leaving Temperature Setpoint Node Name' },
    ],
  },
  {
    componentType: 'chiller-electric-reformulated-eir',
    idfClass: 'Chiller:Electric:ReformulatedEIR',
    nameFieldIndex: 0,
    totalFields: 36,
    fieldMappings: {},
    portMappings: [
      { portId: 'chilled-water-inlet', fieldIndex: 15, fieldName: 'Chilled Water Inlet Node Name' },
      { portId: 'chilled-water-outlet', fieldIndex: 16, fieldName: 'Chilled Water Outlet Node Name' },
      { portId: 'condenser-inlet', fieldIndex: 17, fieldName: 'Condenser Inlet Node Name' },
      { portId: 'condenser-outlet', fieldIndex: 18, fieldName: 'Condenser Outlet Node Name' },
      { portId: 'heat-recovery-inlet', fieldIndex: 23, fieldName: 'Heat Recovery Inlet Node Name' },
      { portId: 'heat-recovery-outlet', fieldIndex: 24, fieldName: 'Heat Recovery Outlet Node Name' },
      { portId: 'heat-recovery-leaving-temperature-setpoint', fieldIndex: 28, fieldName: 'Heat Recovery Leaving Temperature Setpoint Node Name' },
    ],
  },
  {
    componentType: 'chiller-electric',
    idfClass: 'Chiller:Electric',
    nameFieldIndex: 0,
    totalFields: 40,
    fieldMappings: {},
    portMappings: [
      { portId: 'chilled-water-inlet', fieldIndex: 4, fieldName: 'Chilled Water Inlet Node Name' },
      { portId: 'chilled-water-outlet', fieldIndex: 5, fieldName: 'Chilled Water Outlet Node Name' },
      { portId: 'condenser-inlet', fieldIndex: 6, fieldName: 'Condenser Inlet Node Name' },
      { portId: 'condenser-outlet', fieldIndex: 7, fieldName: 'Condenser Outlet Node Name' },
      { portId: 'heat-recovery-inlet', fieldIndex: 28, fieldName: 'Heat Recovery Inlet Node Name' },
      { portId: 'heat-recovery-outlet', fieldIndex: 29, fieldName: 'Heat Recovery Outlet Node Name' },
      { portId: 'heat-recovery-leaving-temperature-setpoint', fieldIndex: 36, fieldName: 'Heat Recovery Leaving Temperature Setpoint Node Name' },
    ],
  },
  {
    componentType: 'chiller-absorption-indirect',
    idfClass: 'Chiller:Absorption:Indirect',
    nameFieldIndex: 0,
    totalFields: 31,
    fieldMappings: {},
    portMappings: [
      { portId: 'chilled-water-inlet', fieldIndex: 3, fieldName: 'Chilled Water Inlet Node Name' },
      { portId: 'chilled-water-outlet', fieldIndex: 4, fieldName: 'Chilled Water Outlet Node Name' },
      { portId: 'condenser-inlet', fieldIndex: 5, fieldName: 'Condenser Inlet Node Name' },
      { portId: 'condenser-outlet', fieldIndex: 6, fieldName: 'Condenser Outlet Node Name' },
      { portId: 'generator-inlet', fieldIndex: 18, fieldName: 'Generator Inlet Node Name' },
      { portId: 'generator-outlet', fieldIndex: 19, fieldName: 'Generator Outlet Node Name' },
    ],
  },
  {
    componentType: 'chiller-absorption',
    idfClass: 'Chiller:Absorption',
    nameFieldIndex: 0,
    totalFields: 27,
    fieldMappings: {},
    portMappings: [
      { portId: 'chilled-water-inlet', fieldIndex: 3, fieldName: 'Chilled Water Inlet Node Name' },
      { portId: 'chilled-water-outlet', fieldIndex: 4, fieldName: 'Chilled Water Outlet Node Name' },
      { portId: 'condenser-inlet', fieldIndex: 5, fieldName: 'Condenser Inlet Node Name' },
      { portId: 'condenser-outlet', fieldIndex: 6, fieldName: 'Condenser Outlet Node Name' },
      { portId: 'generator-inlet', fieldIndex: 20, fieldName: 'Generator Inlet Node Name' },
      { portId: 'generator-outlet', fieldIndex: 21, fieldName: 'Generator Outlet Node Name' },
    ],
  },
  {
    componentType: 'chiller-constant-cop',
    idfClass: 'Chiller:ConstantCOP',
    nameFieldIndex: 0,
    totalFields: 17,
    fieldMappings: {},
    portMappings: [
      { portId: 'chilled-water-inlet', fieldIndex: 5, fieldName: 'Chilled Water Inlet Node Name' },
      { portId: 'chilled-water-outlet', fieldIndex: 6, fieldName: 'Chilled Water Outlet Node Name' },
      { portId: 'condenser-inlet', fieldIndex: 7, fieldName: 'Condenser Inlet Node Name' },
      { portId: 'condenser-outlet', fieldIndex: 8, fieldName: 'Condenser Outlet Node Name' },
    ],
  },
  {
    componentType: 'chiller-engine-driven',
    idfClass: 'Chiller:EngineDriven',
    nameFieldIndex: 0,
    totalFields: 47,
    fieldMappings: {},
    portMappings: [
      { portId: 'chilled-water-inlet', fieldIndex: 4, fieldName: 'Chilled Water Inlet Node Name' },
      { portId: 'chilled-water-outlet', fieldIndex: 5, fieldName: 'Chilled Water Outlet Node Name' },
      { portId: 'condenser-inlet', fieldIndex: 6, fieldName: 'Condenser Inlet Node Name' },
      { portId: 'condenser-outlet', fieldIndex: 7, fieldName: 'Condenser Outlet Node Name' },
      { portId: 'heat-recovery-inlet', fieldIndex: 38, fieldName: 'Heat Recovery Inlet Node Name' },
      { portId: 'heat-recovery-outlet', fieldIndex: 39, fieldName: 'Heat Recovery Outlet Node Name' },
    ],
  },
  {
    componentType: 'chiller-combustion-turbine',
    idfClass: 'Chiller:CombustionTurbine',
    nameFieldIndex: 0,
    totalFields: 62,
    fieldMappings: {},
    portMappings: [
      { portId: 'chilled-water-inlet', fieldIndex: 4, fieldName: 'Chilled Water Inlet Node Name' },
      { portId: 'chilled-water-outlet', fieldIndex: 5, fieldName: 'Chilled Water Outlet Node Name' },
      { portId: 'condenser-inlet', fieldIndex: 6, fieldName: 'Condenser Inlet Node Name' },
      { portId: 'condenser-outlet', fieldIndex: 7, fieldName: 'Condenser Outlet Node Name' },
      { portId: 'heat-recovery-inlet', fieldIndex: 51, fieldName: 'Heat Recovery Inlet Node Name' },
      { portId: 'heat-recovery-outlet', fieldIndex: 52, fieldName: 'Heat Recovery Outlet Node Name' },
    ],
  },
  {
    componentType: 'chiller-heater-absorption-direct-fired',
    idfClass: 'ChillerHeater:Absorption:DirectFired',
    nameFieldIndex: 0,
    totalFields: 34,
    fieldMappings: {},
    portMappings: [
      { portId: 'chilled-water-inlet', fieldIndex: 7, fieldName: 'Chilled Water Inlet Node Name' },
      { portId: 'chilled-water-outlet', fieldIndex: 8, fieldName: 'Chilled Water Outlet Node Name' },
      { portId: 'condenser-inlet', fieldIndex: 9, fieldName: 'Condenser Inlet Node Name' },
      { portId: 'condenser-outlet', fieldIndex: 10, fieldName: 'Condenser Outlet Node Name' },
      { portId: 'hot-water-inlet', fieldIndex: 11, fieldName: 'Hot Water Inlet Node Name' },
      { portId: 'hot-water-outlet', fieldIndex: 12, fieldName: 'Hot Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'chiller-heater-absorption-double-effect',
    idfClass: 'ChillerHeater:Absorption:DoubleEffect',
    nameFieldIndex: 0,
    totalFields: 34,
    fieldMappings: {},
    portMappings: [
      { portId: 'chilled-water-inlet', fieldIndex: 7, fieldName: 'Chilled Water Inlet Node Name' },
      { portId: 'chilled-water-outlet', fieldIndex: 8, fieldName: 'Chilled Water Outlet Node Name' },
      { portId: 'condenser-inlet', fieldIndex: 9, fieldName: 'Condenser Inlet Node Name' },
      { portId: 'condenser-outlet', fieldIndex: 10, fieldName: 'Condenser Outlet Node Name' },
      { portId: 'hot-water-inlet', fieldIndex: 11, fieldName: 'Hot Water Inlet Node Name' },
      { portId: 'hot-water-outlet', fieldIndex: 12, fieldName: 'Hot Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'heat-pump-plant-loop-eir-cooling',
    idfClass: 'HeatPump:PlantLoop:EIR:Cooling',
    nameFieldIndex: 0,
    totalFields: 30,
    fieldMappings: {},
    portMappings: [
      { portId: 'load-side-inlet', fieldIndex: 1, fieldName: 'Load Side Inlet Node Name' },
      { portId: 'load-side-outlet', fieldIndex: 2, fieldName: 'Load Side Outlet Node Name' },
      { portId: 'source-side-inlet', fieldIndex: 4, fieldName: 'Source Side Inlet Node Name' },
      { portId: 'source-side-outlet', fieldIndex: 5, fieldName: 'Source Side Outlet Node Name' },
      { portId: 'heat-recovery-inlet', fieldIndex: 6, fieldName: 'Heat Recovery Inlet Node Name' },
      { portId: 'heat-recovery-outlet', fieldIndex: 7, fieldName: 'Heat Recovery Outlet Node Name' },
    ],
  },
  {
    componentType: 'heat-pump-plant-loop-eir-heating',
    idfClass: 'HeatPump:PlantLoop:EIR:Heating',
    nameFieldIndex: 0,
    totalFields: 38,
    fieldMappings: {},
    portMappings: [
      { portId: 'load-side-inlet', fieldIndex: 1, fieldName: 'Load Side Inlet Node Name' },
      { portId: 'load-side-outlet', fieldIndex: 2, fieldName: 'Load Side Outlet Node Name' },
      { portId: 'source-side-inlet', fieldIndex: 4, fieldName: 'Source Side Inlet Node Name' },
      { portId: 'source-side-outlet', fieldIndex: 5, fieldName: 'Source Side Outlet Node Name' },
      { portId: 'heat-recovery-inlet', fieldIndex: 6, fieldName: 'Heat Recovery Inlet Node Name' },
      { portId: 'heat-recovery-outlet', fieldIndex: 7, fieldName: 'Heat Recovery Outlet Node Name' },
    ],
  },
  {
    componentType: 'heat-pump-air-to-water-fuel-fired-heating',
    idfClass: 'HeatPump:AirToWater:FuelFired:Heating',
    nameFieldIndex: 0,
    totalFields: 32,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 1, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 2, fieldName: 'Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'heat-pump-air-to-water-fuel-fired-cooling',
    idfClass: 'HeatPump:AirToWater:FuelFired:Cooling',
    nameFieldIndex: 0,
    totalFields: 27,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 1, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 2, fieldName: 'Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'heat-pump-air-to-water',
    idfClass: 'HeatPump:AirToWater',
    nameFieldIndex: 0,
    totalFields: 105,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 25, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 26, fieldName: 'Air Outlet Node Name' },
      { portId: 'hot-water-inlet', fieldIndex: 27, fieldName: 'Hot Water Inlet Node Name' },
      { portId: 'hot-water-outlet', fieldIndex: 28, fieldName: 'Hot Water Outlet Node Name' },
      { portId: 'chilled-water-inlet', fieldIndex: 29, fieldName: 'Chilled Water Inlet Node Name' },
      { portId: 'chilled-water-outlet', fieldIndex: 30, fieldName: 'Chilled Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'heat-pump-water-to-water-equation-fit-heating',
    idfClass: 'HeatPump:WaterToWater:EquationFit:Heating',
    nameFieldIndex: 0,
    totalFields: 14,
    fieldMappings: {},
    portMappings: [
      { portId: 'source-side-inlet', fieldIndex: 1, fieldName: 'Source Side Inlet Node Name' },
      { portId: 'source-side-outlet', fieldIndex: 2, fieldName: 'Source Side Outlet Node Name' },
      { portId: 'load-side-inlet', fieldIndex: 3, fieldName: 'Load Side Inlet Node Name' },
      { portId: 'load-side-outlet', fieldIndex: 4, fieldName: 'Load Side Outlet Node Name' },
    ],
  },
  {
    componentType: 'heat-pump-water-to-water-equation-fit-cooling',
    idfClass: 'HeatPump:WaterToWater:EquationFit:Cooling',
    nameFieldIndex: 0,
    totalFields: 14,
    fieldMappings: {},
    portMappings: [
      { portId: 'source-side-inlet', fieldIndex: 1, fieldName: 'Source Side Inlet Node Name' },
      { portId: 'source-side-outlet', fieldIndex: 2, fieldName: 'Source Side Outlet Node Name' },
      { portId: 'load-side-inlet', fieldIndex: 3, fieldName: 'Load Side Inlet Node Name' },
      { portId: 'load-side-outlet', fieldIndex: 4, fieldName: 'Load Side Outlet Node Name' },
    ],
  },
  {
    componentType: 'heat-pump-water-to-water-parameter-estimation-cooling',
    idfClass: 'HeatPump:WaterToWater:ParameterEstimation:Cooling',
    nameFieldIndex: 0,
    totalFields: 22,
    fieldMappings: {},
    portMappings: [
      { portId: 'source-side-inlet', fieldIndex: 1, fieldName: 'Source Side Inlet Node Name' },
      { portId: 'source-side-outlet', fieldIndex: 2, fieldName: 'Source Side Outlet Node Name' },
      { portId: 'load-side-inlet', fieldIndex: 3, fieldName: 'Load Side Inlet Node Name' },
      { portId: 'load-side-outlet', fieldIndex: 4, fieldName: 'Load Side Outlet Node Name' },
    ],
  },
  {
    componentType: 'heat-pump-water-to-water-parameter-estimation-heating',
    idfClass: 'HeatPump:WaterToWater:ParameterEstimation:Heating',
    nameFieldIndex: 0,
    totalFields: 22,
    fieldMappings: {},
    portMappings: [
      { portId: 'source-side-inlet', fieldIndex: 1, fieldName: 'Source Side Inlet Node Name' },
      { portId: 'source-side-outlet', fieldIndex: 2, fieldName: 'Source Side Outlet Node Name' },
      { portId: 'load-side-inlet', fieldIndex: 3, fieldName: 'Load Side Inlet Node Name' },
      { portId: 'load-side-outlet', fieldIndex: 4, fieldName: 'Load Side Outlet Node Name' },
    ],
  },
  {
    componentType: 'district-cooling',
    idfClass: 'DistrictCooling',
    nameFieldIndex: 0,
    totalFields: 5,
    fieldMappings: {},
    portMappings: [
      { portId: 'chilled-water-inlet', fieldIndex: 1, fieldName: 'Chilled Water Inlet Node Name' },
      { portId: 'chilled-water-outlet', fieldIndex: 2, fieldName: 'Chilled Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'district-heating-water',
    idfClass: 'DistrictHeating:Water',
    nameFieldIndex: 0,
    totalFields: 5,
    fieldMappings: {},
    portMappings: [
      { portId: 'hot-water-inlet', fieldIndex: 1, fieldName: 'Hot Water Inlet Node Name' },
      { portId: 'hot-water-outlet', fieldIndex: 2, fieldName: 'Hot Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'district-heating-steam',
    idfClass: 'DistrictHeating:Steam',
    nameFieldIndex: 0,
    totalFields: 5,
    fieldMappings: {},
    portMappings: [
      { portId: 'steam-inlet', fieldIndex: 1, fieldName: 'Steam Inlet Node Name' },
      { portId: 'steam-outlet', fieldIndex: 2, fieldName: 'Steam Outlet Node Name' },
    ],
  },
  {
    componentType: 'plant-component-temperature-source',
    idfClass: 'PlantComponent:TemperatureSource',
    nameFieldIndex: 0,
    totalFields: 7,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet-node', fieldIndex: 1, fieldName: 'Inlet Node' },
      { portId: 'outlet-node', fieldIndex: 2, fieldName: 'Outlet Node' },
    ],
  },
  {
    componentType: 'central-heat-pump-system',
    idfClass: 'CentralHeatPumpSystem',
    nameFieldIndex: 0,
    totalFields: 90,
    fieldMappings: {},
    portMappings: [
      { portId: 'cooling-loop-inlet', fieldIndex: 2, fieldName: 'Cooling Loop Inlet Node Name' },
      { portId: 'cooling-loop-outlet', fieldIndex: 3, fieldName: 'Cooling Loop Outlet Node Name' },
      { portId: 'source-loop-inlet', fieldIndex: 4, fieldName: 'Source Loop Inlet Node Name' },
      { portId: 'source-loop-outlet', fieldIndex: 5, fieldName: 'Source Loop Outlet Node Name' },
      { portId: 'heating-loop-inlet', fieldIndex: 6, fieldName: 'Heating Loop Inlet Node Name' },
      { portId: 'heating-loop-outlet', fieldIndex: 7, fieldName: 'Heating Loop Outlet Node Name' },
    ],
  },
  {
    componentType: 'cooling-tower-single-speed',
    idfClass: 'CoolingTower:SingleSpeed',
    nameFieldIndex: 0,
    totalFields: 38,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 1, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 2, fieldName: 'Water Outlet Node Name' },
      { portId: 'outdoor-air-inlet', fieldIndex: 30, fieldName: 'Outdoor Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'cooling-tower-two-speed',
    idfClass: 'CoolingTower:TwoSpeed',
    nameFieldIndex: 0,
    totalFields: 45,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 1, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 2, fieldName: 'Water Outlet Node Name' },
      { portId: 'outdoor-air-inlet', fieldIndex: 38, fieldName: 'Outdoor Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'cooling-tower-variable-speed-merkel',
    idfClass: 'CoolingTower:VariableSpeed:Merkel',
    nameFieldIndex: 0,
    totalFields: 45,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 1, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 2, fieldName: 'Water Outlet Node Name' },
      { portId: 'outdoor-air-inlet', fieldIndex: 38, fieldName: 'Outdoor Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'cooling-tower-variable-speed',
    idfClass: 'CoolingTower:VariableSpeed',
    nameFieldIndex: 0,
    totalFields: 31,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 1, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 2, fieldName: 'Water Outlet Node Name' },
      { portId: 'outdoor-air-inlet', fieldIndex: 24, fieldName: 'Outdoor Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'evaporative-fluid-cooler-single-speed',
    idfClass: 'EvaporativeFluidCooler:SingleSpeed',
    nameFieldIndex: 0,
    totalFields: 25,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 1, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 2, fieldName: 'Water Outlet Node Name' },
      { portId: 'outdoor-air-inlet', fieldIndex: 7, fieldName: 'Outdoor Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'evaporative-fluid-cooler-two-speed',
    idfClass: 'EvaporativeFluidCooler:TwoSpeed',
    nameFieldIndex: 0,
    totalFields: 34,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 1, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 2, fieldName: 'Water Outlet Node Name' },
      { portId: 'outdoor-air-inlet', fieldIndex: 11, fieldName: 'Outdoor Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'fluid-cooler-single-speed',
    idfClass: 'FluidCooler:SingleSpeed',
    nameFieldIndex: 0,
    totalFields: 13,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 1, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 2, fieldName: 'Water Outlet Node Name' },
      { portId: 'outdoor-air-inlet', fieldIndex: 12, fieldName: 'Outdoor Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'fluid-cooler-two-speed',
    idfClass: 'FluidCooler:TwoSpeed',
    nameFieldIndex: 0,
    totalFields: 21,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 1, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 2, fieldName: 'Water Outlet Node Name' },
      { portId: 'outdoor-air-inlet', fieldIndex: 20, fieldName: 'Outdoor Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'ground-heat-exchanger-system',
    idfClass: 'GroundHeatExchanger:System',
    nameFieldIndex: 0,
    totalFields: 113,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 2, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'ground-heat-exchanger-pond',
    idfClass: 'GroundHeatExchanger:Pond',
    nameFieldIndex: 0,
    totalFields: 11,
    fieldMappings: {},
    portMappings: [
      { portId: 'fluid-inlet', fieldIndex: 1, fieldName: 'Fluid Inlet Node Name' },
      { portId: 'fluid-outlet', fieldIndex: 2, fieldName: 'Fluid Outlet Node Name' },
    ],
  },
  {
    componentType: 'ground-heat-exchanger-surface',
    idfClass: 'GroundHeatExchanger:Surface',
    nameFieldIndex: 0,
    totalFields: 10,
    fieldMappings: {},
    portMappings: [
      { portId: 'fluid-inlet', fieldIndex: 2, fieldName: 'Fluid Inlet Node Name' },
      { portId: 'fluid-outlet', fieldIndex: 3, fieldName: 'Fluid Outlet Node Name' },
    ],
  },
  {
    componentType: 'ground-heat-exchanger-horizontal-trench',
    idfClass: 'GroundHeatExchanger:HorizontalTrench',
    nameFieldIndex: 0,
    totalFields: 21,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 2, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'ground-heat-exchanger-slinky',
    idfClass: 'GroundHeatExchanger:Slinky',
    nameFieldIndex: 0,
    totalFields: 22,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 2, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'heat-exchanger-fluid-to-fluid',
    idfClass: 'HeatExchanger:FluidToFluid',
    nameFieldIndex: 0,
    totalFields: 20,
    fieldMappings: {},
    portMappings: [
      { portId: 'loop-demand-side-inlet', fieldIndex: 2, fieldName: 'Loop Demand Side Inlet Node Name' },
      { portId: 'loop-demand-side-outlet', fieldIndex: 3, fieldName: 'Loop Demand Side Outlet Node Name' },
      { portId: 'loop-supply-side-inlet', fieldIndex: 5, fieldName: 'Loop Supply Side Inlet Node Name' },
      { portId: 'loop-supply-side-outlet', fieldIndex: 6, fieldName: 'Loop Supply Side Outlet Node Name' },
      { portId: 'component-override-loop-supply-side-inlet', fieldIndex: 14, fieldName: 'Component Override Loop Supply Side Inlet Node Name' },
      { portId: 'component-override-loop-demand-side-inlet', fieldIndex: 15, fieldName: 'Component Override Loop Demand Side Inlet Node Name' },
    ],
  },
  {
    componentType: 'water-heater-mixed',
    idfClass: 'WaterHeater:Mixed',
    nameFieldIndex: 0,
    totalFields: 42,
    fieldMappings: {},
    portMappings: [
      { portId: 'use-side-inlet', fieldIndex: 30, fieldName: 'Use Side Inlet Node Name' },
      { portId: 'use-side-outlet', fieldIndex: 31, fieldName: 'Use Side Outlet Node Name' },
      { portId: 'source-side-inlet', fieldIndex: 33, fieldName: 'Source Side Inlet Node Name' },
      { portId: 'source-side-outlet', fieldIndex: 34, fieldName: 'Source Side Outlet Node Name' },
    ],
  },
  {
    componentType: 'water-heater-stratified',
    idfClass: 'WaterHeater:Stratified',
    nameFieldIndex: 0,
    totalFields: 67,
    fieldMappings: {},
    portMappings: [
      { portId: 'use-side-inlet', fieldIndex: 37, fieldName: 'Use Side Inlet Node Name' },
      { portId: 'use-side-outlet', fieldIndex: 38, fieldName: 'Use Side Outlet Node Name' },
      { portId: 'source-side-inlet', fieldIndex: 42, fieldName: 'Source Side Inlet Node Name' },
      { portId: 'source-side-outlet', fieldIndex: 43, fieldName: 'Source Side Outlet Node Name' },
    ],
  },
  {
    componentType: 'water-heater-heat-pump-pumped-condenser',
    idfClass: 'WaterHeater:HeatPump:PumpedCondenser',
    nameFieldIndex: 0,
    totalFields: 39,
    fieldMappings: {},
    portMappings: [
      { portId: 'condenser-water-inlet', fieldIndex: 4, fieldName: 'Condenser Water Inlet Node Name' },
      { portId: 'condenser-water-outlet', fieldIndex: 5, fieldName: 'Condenser Water Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 9, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 10, fieldName: 'Air Outlet Node Name' },
      { portId: 'tank-use-side-inlet', fieldIndex: 18, fieldName: 'Tank Use Side Inlet Node Name' },
      { portId: 'tank-use-side-outlet', fieldIndex: 19, fieldName: 'Tank Use Side Outlet Node Name' },
      { portId: 'inlet-air-mixer', fieldIndex: 32, fieldName: 'Inlet Air Mixer Node Name' },
      { portId: 'outlet-air-splitter', fieldIndex: 33, fieldName: 'Outlet Air Splitter Node Name' },
    ],
  },
  {
    componentType: 'water-heater-heat-pump-wrapped-condenser',
    idfClass: 'WaterHeater:HeatPump:WrappedCondenser',
    nameFieldIndex: 0,
    totalFields: 38,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 8, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 9, fieldName: 'Air Outlet Node Name' },
      { portId: 'tank-use-side-inlet', fieldIndex: 17, fieldName: 'Tank Use Side Inlet Node Name' },
      { portId: 'tank-use-side-outlet', fieldIndex: 18, fieldName: 'Tank Use Side Outlet Node Name' },
      { portId: 'inlet-air-mixer', fieldIndex: 31, fieldName: 'Inlet Air Mixer Node Name' },
      { portId: 'outlet-air-splitter', fieldIndex: 32, fieldName: 'Outlet Air Splitter Node Name' },
    ],
  },
  {
    componentType: 'thermal-storage-ice-simple',
    idfClass: 'ThermalStorage:Ice:Simple',
    nameFieldIndex: 0,
    totalFields: 6,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 3, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 4, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'thermal-storage-ice-detailed',
    idfClass: 'ThermalStorage:Ice:Detailed',
    nameFieldIndex: 0,
    totalFields: 16,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 3, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 4, fieldName: 'Outlet Node Name' },
    ],
  },
  {
    componentType: 'thermal-storage-chilled-water-mixed',
    idfClass: 'ThermalStorage:ChilledWater:Mixed',
    nameFieldIndex: 0,
    totalFields: 22,
    fieldMappings: {},
    portMappings: [
      { portId: 'use-side-inlet', fieldIndex: 11, fieldName: 'Use Side Inlet Node Name' },
      { portId: 'use-side-outlet', fieldIndex: 12, fieldName: 'Use Side Outlet Node Name' },
      { portId: 'source-side-inlet', fieldIndex: 16, fieldName: 'Source Side Inlet Node Name' },
      { portId: 'source-side-outlet', fieldIndex: 17, fieldName: 'Source Side Outlet Node Name' },
    ],
  },
  {
    componentType: 'thermal-storage-chilled-water-stratified',
    idfClass: 'ThermalStorage:ChilledWater:Stratified',
    nameFieldIndex: 0,
    totalFields: 43,
    fieldMappings: {},
    portMappings: [
      { portId: 'use-side-inlet', fieldIndex: 15, fieldName: 'Use Side Inlet Node Name' },
      { portId: 'use-side-outlet', fieldIndex: 16, fieldName: 'Use Side Outlet Node Name' },
      { portId: 'source-side-inlet', fieldIndex: 22, fieldName: 'Source Side Inlet Node Name' },
      { portId: 'source-side-outlet', fieldIndex: 23, fieldName: 'Source Side Outlet Node Name' },
    ],
  },
  {
    componentType: 'thermal-storage-hot-water-stratified',
    idfClass: 'ThermalStorage:HotWater:Stratified',
    nameFieldIndex: 0,
    totalFields: 47,
    fieldMappings: {},
    portMappings: [
      { portId: 'use-side-inlet', fieldIndex: 17, fieldName: 'Use Side Inlet Node Name' },
      { portId: 'use-side-outlet', fieldIndex: 18, fieldName: 'Use Side Outlet Node Name' },
      { portId: 'source-side-inlet', fieldIndex: 25, fieldName: 'Source Side Inlet Node Name' },
      { portId: 'source-side-outlet', fieldIndex: 26, fieldName: 'Source Side Outlet Node Name' },
    ],
  },
  {
    componentType: 'thermal-storage-pcm',
    idfClass: 'ThermalStorage:PCM',
    nameFieldIndex: 0,
    totalFields: 11,
    fieldMappings: {},
    portMappings: [
      { portId: 'plant-side-inlet', fieldIndex: 2, fieldName: 'Plant Side Inlet Node Name' },
      { portId: 'plant-side-outlet', fieldIndex: 3, fieldName: 'Plant Side Outlet Node Name' },
      { portId: 'use-side-inlet', fieldIndex: 4, fieldName: 'Use Side Inlet Node Name' },
      { portId: 'use-side-outlet', fieldIndex: 5, fieldName: 'Use Side Outlet Node Name' },
    ],
  },
  {
    componentType: 'plant-loop',
    idfClass: 'PlantLoop',
    nameFieldIndex: 0,
    totalFields: 24,
    fieldMappings: {},
    portMappings: [
      { portId: 'plant-side-inlet', fieldIndex: 10, fieldName: 'Plant Side Inlet Node Name' },
      { portId: 'plant-side-outlet', fieldIndex: 11, fieldName: 'Plant Side Outlet Node Name' },
      { portId: 'demand-side-inlet', fieldIndex: 14, fieldName: 'Demand Side Inlet Node Name' },
      { portId: 'demand-side-outlet', fieldIndex: 15, fieldName: 'Demand Side Outlet Node Name' },
    ],
  },
  {
    componentType: 'condenser-loop',
    idfClass: 'CondenserLoop',
    nameFieldIndex: 0,
    totalFields: 21,
    fieldMappings: {},
    portMappings: [
      { portId: 'condenser-side-inlet', fieldIndex: 10, fieldName: 'Condenser Side Inlet Node Name' },
      { portId: 'condenser-side-outlet', fieldIndex: 11, fieldName: 'Condenser Side Outlet Node Name' },
      { portId: 'demand-side-inlet', fieldIndex: 14, fieldName: 'Demand Side Inlet Node Name' },
      { portId: 'demand-side-outlet', fieldIndex: 15, fieldName: 'Demand Side Outlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-forced-air-user-defined',
    idfClass: 'ZoneHVAC:ForcedAir:UserDefined',
    nameFieldIndex: 0,
    totalFields: 17,
    fieldMappings: {},
    portMappings: [
      { portId: 'primary-air-inlet', fieldIndex: 3, fieldName: 'Primary Air Inlet Node Name' },
      { portId: 'primary-air-outlet', fieldIndex: 4, fieldName: 'Primary Air Outlet Node Name' },
      { portId: 'secondary-air-inlet', fieldIndex: 5, fieldName: 'Secondary Air Inlet Node Name' },
      { portId: 'secondary-air-outlet', fieldIndex: 6, fieldName: 'Secondary Air Outlet Node Name' },
      { portId: 'plant-connection-1-inlet', fieldIndex: 8, fieldName: 'Plant Connection 1 Inlet Node Name' },
      { portId: 'plant-connection-1-outlet', fieldIndex: 9, fieldName: 'Plant Connection 1 Outlet Node Name' },
      { portId: 'plant-connection-2-inlet', fieldIndex: 10, fieldName: 'Plant Connection 2 Inlet Node Name' },
      { portId: 'plant-connection-2-outlet', fieldIndex: 11, fieldName: 'Plant Connection 2 Outlet Node Name' },
      { portId: 'plant-connection-3-inlet', fieldIndex: 12, fieldName: 'Plant Connection 3 Inlet Node Name' },
      { portId: 'plant-connection-3-outlet', fieldIndex: 13, fieldName: 'Plant Connection 3 Outlet Node Name' },
    ],
  },
  {
    componentType: 'air-terminal-single-duct-user-defined',
    idfClass: 'AirTerminal:SingleDuct:UserDefined',
    nameFieldIndex: 0,
    totalFields: 15,
    fieldMappings: {},
    portMappings: [
      { portId: 'primary-air-inlet', fieldIndex: 3, fieldName: 'Primary Air Inlet Node Name' },
      { portId: 'primary-air-outlet', fieldIndex: 4, fieldName: 'Primary Air Outlet Node Name' },
      { portId: 'secondary-air-inlet', fieldIndex: 5, fieldName: 'Secondary Air Inlet Node Name' },
      { portId: 'secondary-air-outlet', fieldIndex: 6, fieldName: 'Secondary Air Outlet Node Name' },
      { portId: 'plant-connection-1-inlet', fieldIndex: 8, fieldName: 'Plant Connection 1 Inlet Node Name' },
      { portId: 'plant-connection-1-outlet', fieldIndex: 9, fieldName: 'Plant Connection 1 Outlet Node Name' },
      { portId: 'plant-connection-2-inlet', fieldIndex: 10, fieldName: 'Plant Connection 2 Inlet Node Name' },
      { portId: 'plant-connection-2-outlet', fieldIndex: 11, fieldName: 'Plant Connection 2 Outlet Node Name' },
    ],
  },
  {
    componentType: 'coil-user-defined',
    idfClass: 'Coil:UserDefined',
    nameFieldIndex: 0,
    totalFields: 14,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-connection-1-inlet', fieldIndex: 4, fieldName: 'Air Connection 1 Inlet Node Name' },
      { portId: 'air-connection-1-outlet', fieldIndex: 5, fieldName: 'Air Connection 1 Outlet Node Name' },
      { portId: 'air-connection-2-inlet', fieldIndex: 6, fieldName: 'Air Connection 2 Inlet Node Name' },
      { portId: 'air-connection-2-outlet', fieldIndex: 7, fieldName: 'Air Connection 2 Outlet Node Name' },
      { portId: 'plant-connection-inlet', fieldIndex: 9, fieldName: 'Plant Connection Inlet Node Name' },
      { portId: 'plant-connection-outlet', fieldIndex: 10, fieldName: 'Plant Connection Outlet Node Name' },
    ],
  },
  {
    componentType: 'plant-component-user-defined',
    idfClass: 'PlantComponent:UserDefined',
    nameFieldIndex: 0,
    totalFields: 32,
    fieldMappings: {},
    portMappings: [
      { portId: 'plant-connection-1-inlet', fieldIndex: 3, fieldName: 'Plant Connection 1 Inlet Node Name' },
      { portId: 'plant-connection-1-outlet', fieldIndex: 4, fieldName: 'Plant Connection 1 Outlet Node Name' },
      { portId: 'plant-connection-2-inlet', fieldIndex: 9, fieldName: 'Plant Connection 2 Inlet Node Name' },
      { portId: 'plant-connection-2-outlet', fieldIndex: 10, fieldName: 'Plant Connection 2 Outlet Node Name' },
      { portId: 'plant-connection-3-inlet', fieldIndex: 15, fieldName: 'Plant Connection 3 Inlet Node Name' },
      { portId: 'plant-connection-3-outlet', fieldIndex: 16, fieldName: 'Plant Connection 3 Outlet Node Name' },
      { portId: 'plant-connection-4-inlet', fieldIndex: 21, fieldName: 'Plant Connection 4 Inlet Node Name' },
      { portId: 'plant-connection-4-outlet', fieldIndex: 22, fieldName: 'Plant Connection 4 Outlet Node Name' },
      { portId: 'air-connection-inlet', fieldIndex: 27, fieldName: 'Air Connection Inlet Node Name' },
      { portId: 'air-connection-outlet', fieldIndex: 28, fieldName: 'Air Connection Outlet Node Name' },
    ],
  },
  {
    componentType: 'setpoint-manager-single-zone-reheat',
    idfClass: 'SetpointManager:SingleZone:Reheat',
    nameFieldIndex: 0,
    totalFields: 8,
    fieldMappings: {},
    portMappings: [
      { portId: 'zone-inlet', fieldIndex: 6, fieldName: 'Zone Inlet Node Name' },
    ],
  },
  {
    componentType: 'setpoint-manager-single-zone-heating',
    idfClass: 'SetpointManager:SingleZone:Heating',
    nameFieldIndex: 0,
    totalFields: 8,
    fieldMappings: {},
    portMappings: [
      { portId: 'zone-inlet', fieldIndex: 6, fieldName: 'Zone Inlet Node Name' },
    ],
  },
  {
    componentType: 'setpoint-manager-single-zone-cooling',
    idfClass: 'SetpointManager:SingleZone:Cooling',
    nameFieldIndex: 0,
    totalFields: 8,
    fieldMappings: {},
    portMappings: [
      { portId: 'zone-inlet', fieldIndex: 6, fieldName: 'Zone Inlet Node Name' },
    ],
  },
  {
    componentType: 'setpoint-manager-mixed-air',
    idfClass: 'SetpointManager:MixedAir',
    nameFieldIndex: 0,
    totalFields: 9,
    fieldMappings: {},
    portMappings: [
      { portId: 'fan-inlet', fieldIndex: 3, fieldName: 'Fan Inlet Node Name' },
      { portId: 'fan-outlet', fieldIndex: 4, fieldName: 'Fan Outlet Node Name' },
      { portId: 'cooling-coil-inlet', fieldIndex: 6, fieldName: 'Cooling Coil Inlet Node Name' },
      { portId: 'cooling-coil-outlet', fieldIndex: 7, fieldName: 'Cooling coil Outlet Node Name' },
    ],
  },
  {
    componentType: 'setpoint-manager-outdoor-air-pretreat',
    idfClass: 'SetpointManager:OutdoorAirPretreat',
    nameFieldIndex: 0,
    totalFields: 11,
    fieldMappings: {},
    portMappings: [
      { portId: 'return-air-stream', fieldIndex: 9, fieldName: 'Return Air Stream Node Name' },
    ],
  },
  {
    componentType: 'setpoint-manager-return-temperature-chilled-water',
    idfClass: 'SetpointManager:ReturnTemperature:ChilledWater',
    nameFieldIndex: 0,
    totalFields: 8,
    fieldMappings: {},
    portMappings: [
      { portId: 'plant-loop-supply-outlet-node', fieldIndex: 1, fieldName: 'Plant Loop Supply Outlet Node' },
      { portId: 'plant-loop-supply-inlet-node', fieldIndex: 2, fieldName: 'Plant Loop Supply Inlet Node' },
    ],
  },
  {
    componentType: 'setpoint-manager-return-temperature-hot-water',
    idfClass: 'SetpointManager:ReturnTemperature:HotWater',
    nameFieldIndex: 0,
    totalFields: 8,
    fieldMappings: {},
    portMappings: [
      { portId: 'plant-loop-supply-outlet-node', fieldIndex: 1, fieldName: 'Plant Loop Supply Outlet Node' },
      { portId: 'plant-loop-supply-inlet-node', fieldIndex: 2, fieldName: 'Plant Loop Supply Inlet Node' },
    ],
  },
  {
    componentType: 'refrigeration-case',
    idfClass: 'Refrigeration:Case',
    nameFieldIndex: 0,
    totalFields: 36,
    fieldMappings: {},
    portMappings: [
      { portId: 'under-case-hvac-return-air', fieldIndex: 35, fieldName: 'Under Case HVAC Return Air Node Name' },
    ],
  },
  {
    componentType: 'refrigeration-compressor-rack',
    idfClass: 'Refrigeration:CompressorRack',
    nameFieldIndex: 0,
    totalFields: 26,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-cooled-condenser-inlet', fieldIndex: 7, fieldName: 'Water-Cooled Condenser Inlet Node Name' },
      { portId: 'water-cooled-condenser-outlet', fieldIndex: 8, fieldName: 'Water-Cooled Condenser Outlet Node Name' },
      { portId: 'condenser-air-inlet', fieldIndex: 22, fieldName: 'Condenser Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'refrigeration-condenser-air-cooled',
    idfClass: 'Refrigeration:Condenser:AirCooled',
    nameFieldIndex: 0,
    totalFields: 11,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet-node-name-or-zone-name', fieldIndex: 6, fieldName: 'Air Inlet Node Name or Zone Name' },
    ],
  },
  {
    componentType: 'refrigeration-condenser-evaporative-cooled',
    idfClass: 'Refrigeration:Condenser:EvaporativeCooled',
    nameFieldIndex: 0,
    totalFields: 23,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 12, fieldName: 'Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'refrigeration-condenser-water-cooled',
    idfClass: 'Refrigeration:Condenser:WaterCooled',
    nameFieldIndex: 0,
    totalFields: 17,
    fieldMappings: {},
    portMappings: [
      { portId: 'water-inlet', fieldIndex: 5, fieldName: 'Water Inlet Node Name' },
      { portId: 'water-outlet', fieldIndex: 6, fieldName: 'Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'refrigeration-gas-cooler-air-cooled',
    idfClass: 'Refrigeration:GasCooler:AirCooled',
    nameFieldIndex: 0,
    totalFields: 14,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 9, fieldName: 'Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'zone-hvac-refrigeration-chiller-set',
    idfClass: 'ZoneHVAC:RefrigerationChillerSet',
    nameFieldIndex: 0,
    totalFields: 100,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 3, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 4, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'generator-internal-combustion-engine',
    idfClass: 'Generator:InternalCombustionEngine',
    nameFieldIndex: 0,
    totalFields: 21,
    fieldMappings: {},
    portMappings: [
      { portId: 'heat-recovery-inlet', fieldIndex: 17, fieldName: 'Heat Recovery Inlet Node Name' },
      { portId: 'heat-recovery-outlet', fieldIndex: 18, fieldName: 'Heat Recovery Outlet Node Name' },
    ],
  },
  {
    componentType: 'generator-combustion-turbine',
    idfClass: 'Generator:CombustionTurbine',
    nameFieldIndex: 0,
    totalFields: 24,
    fieldMappings: {},
    portMappings: [
      { portId: 'heat-recovery-inlet', fieldIndex: 19, fieldName: 'Heat Recovery Inlet Node Name' },
      { portId: 'heat-recovery-outlet', fieldIndex: 20, fieldName: 'Heat Recovery Outlet Node Name' },
      { portId: 'outdoor-air-inlet', fieldIndex: 23, fieldName: 'Outdoor Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'generator-micro-turbine',
    idfClass: 'Generator:MicroTurbine',
    nameFieldIndex: 0,
    totalFields: 39,
    fieldMappings: {},
    portMappings: [
      { portId: 'heat-recovery-water-inlet', fieldIndex: 17, fieldName: 'Heat Recovery Water Inlet Node Name' },
      { portId: 'heat-recovery-water-outlet', fieldIndex: 18, fieldName: 'Heat Recovery Water Outlet Node Name' },
      { portId: 'combustion-air-inlet', fieldIndex: 31, fieldName: 'Combustion Air Inlet Node Name' },
      { portId: 'combustion-air-outlet', fieldIndex: 32, fieldName: 'Combustion Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'generator-fuel-cell-power-module',
    idfClass: 'Generator:FuelCell:PowerModule',
    nameFieldIndex: 0,
    totalFields: 33,
    fieldMappings: {},
    portMappings: [
      { portId: 'dilution-inlet-air', fieldIndex: 29, fieldName: 'Dilution Inlet Air Node Name' },
      { portId: 'dilution-outlet-air', fieldIndex: 30, fieldName: 'Dilution Outlet Air Node Name' },
    ],
  },
  {
    componentType: 'generator-fuel-cell-air-supply',
    idfClass: 'Generator:FuelCell:AirSupply',
    nameFieldIndex: 0,
    totalFields: 22,
    fieldMappings: {},
    portMappings: [
      { portId: 'air-inlet', fieldIndex: 1, fieldName: 'Air Inlet Node Name' },
    ],
  },
  {
    componentType: 'generator-fuel-cell-exhaust-gas-to-water-heat-exchanger',
    idfClass: 'Generator:FuelCell:ExhaustGasToWaterHeatExchanger',
    nameFieldIndex: 0,
    totalFields: 24,
    fieldMappings: {},
    portMappings: [
      { portId: 'heat-recovery-water-inlet', fieldIndex: 1, fieldName: 'Heat Recovery Water Inlet Node Name' },
      { portId: 'heat-recovery-water-outlet', fieldIndex: 2, fieldName: 'Heat Recovery Water Outlet Node Name' },
      { portId: 'exhaust-outlet-air', fieldIndex: 4, fieldName: 'Exhaust Outlet Air Node Name' },
    ],
  },
  {
    componentType: 'generator-fuel-cell-stack-cooler',
    idfClass: 'Generator:FuelCell:StackCooler',
    nameFieldIndex: 0,
    totalFields: 21,
    fieldMappings: {},
    portMappings: [
      { portId: 'heat-recovery-water-inlet', fieldIndex: 1, fieldName: 'Heat Recovery Water Inlet Node Name' },
      { portId: 'heat-recovery-water-outlet', fieldIndex: 2, fieldName: 'Heat Recovery Water Outlet Node Name' },
    ],
  },
  {
    componentType: 'generator-micro-chp',
    idfClass: 'Generator:MicroCHP',
    nameFieldIndex: 0,
    totalFields: 9,
    fieldMappings: {},
    portMappings: [
      { portId: 'cooling-water-inlet', fieldIndex: 3, fieldName: 'Cooling Water Inlet Node Name' },
      { portId: 'cooling-water-outlet', fieldIndex: 4, fieldName: 'Cooling Water Outlet Node Name' },
      { portId: 'air-inlet', fieldIndex: 5, fieldName: 'Air Inlet Node Name' },
      { portId: 'air-outlet', fieldIndex: 6, fieldName: 'Air Outlet Node Name' },
    ],
  },
  {
    componentType: 'water-use-connections',
    idfClass: 'WaterUse:Connections',
    nameFieldIndex: 0,
    totalFields: 20,
    fieldMappings: {},
    portMappings: [
      { portId: 'inlet', fieldIndex: 1, fieldName: 'Inlet Node Name' },
      { portId: 'outlet', fieldIndex: 2, fieldName: 'Outlet Node Name' },
    ],
  },
];

// Lookup maps (for fast access)
export const MAPPING_BY_TYPE = new Map<string, ComponentIDFMapping>();
export const MAPPING_BY_IDF_CLASS = new Map<string, ComponentIDFMapping>();

for (const mapping of COMPONENT_IDF_MAPPINGS) {
  MAPPING_BY_TYPE.set(mapping.componentType, mapping);
  MAPPING_BY_IDF_CLASS.set(mapping.idfClass.toLowerCase(), mapping);
}

// Lookup functions
export function getComponentMapping(componentType: string): ComponentIDFMapping | undefined {
  return MAPPING_BY_TYPE.get(componentType);
}

export function getMappingByIDFClass(idfClass: string): ComponentIDFMapping | undefined {
  return MAPPING_BY_IDF_CLASS.get(idfClass.toLowerCase());
}

export function isHVACClass(className: string): boolean {
  return MAPPING_BY_IDF_CLASS.has(className.toLowerCase());
}
